export default {
    "label.update_translations_unsuccessful": "",
    "global.no_records": "பதிவுகள் இல்லை",
    "notifications.rp_has_been_updated": "ரெசிடென்ஷியல் ப்ராஜெக்ட் புதுப்பிக்கப்பட்டது",
    "moduleTitle.files": "கோப்புகள்",
    "label.coordinator": "ஒருங்கிணைப்பாளர்",
    "sidebar.translations_managment": "",
    "table.file": "கோப்பு",
    "label.report_overview": "",
    "label.parent_agreement": "அச்சிடப்பட்ட பெற்றோர் ஒப்புதல் படிவம்",
    "parentalConsent.i_consent_to_and_understand_that": "6. விருதுடன் சம்பந்தப்பட்ட சில செயல்களில் கலந்துகொள்ளும் பங்கேற்பாளரின் புகைப்படங்களை எடுத்துக்கொள்ளலாம் மற்றும் அத்தகைய புகைப்படங்களை விளம்பர நோக்கத்திற்காக பயன்படுத்தலாம் என்று பங்கேற்பாளர் மற்றும் அவர்களது பெற்றோர் / பாதுகாவலர் இருவரும் கையொப்பமிடப்பட்டுள்ளது.",
    "parentalConsent.i_understand_that_participants_are_required_to_comply": "12. பதிவு புத்தகம் அல்லது ORB, தொடர்புடைய விருது ஆபரேட்டர் (அவ்வப்போது திருத்தியமைக்கப்படும்) மற்றும் விருது பிரிவின் தேவைகள் ஆகியவற்றின் நடத்தைக்கான கொள்கைகள் மற்றும் தரநிலைகள் ஆகியவற்றில் உள்ள பங்கேற்பாளர்கள், அவசரத் திட்டங்கள், நடவடிக்கைகளை மதிப்பீடு செய்தல் மற்றும் விருது தொடர்பான துணிகரமான பயணங்களுக்கான நடத்தை ஆகியவற்றைப் புரிந்துகொள்வதன் மூலம், விருது வழங்கியதில் பங்கேற்பாளருக்கு பங்கு வழங்குவதற்கு விருது வழங்கல் பிரிவை அதன் திரும்பப் பெறலாம் என்பதை புரிந்து கொள்ளவும்.",
    "table.end_date": "கடைசி தேதி",
    "label.activation_date": "Activation Date\n",
    "label.report": "",
    "label.award_is_offline": "விருது ஆஃப்லைனில் உள்ளது",
    "label.pending_changes": "மாற்றங்கள் நிலுவையில் உள்ளன ...",
    "errors.min_nights_required": "குறைந்தபட்சம் {nights} இரவு (கள்) தேவைப்படுகிறது",
    "label.country": "நாடு",
    "notifications.award_leader_has_been_returned": "விருதுத் தலைவர் திருத்தப்பட்டது",
    "notifications.participant_has_been_updated": "பங்கேற்பாளர் புதுப்பிக்கப்பட்டது",
    "label.phone_number": "தொலைபேசி எண்",
    "roles.aj_assessor": "சாகச பயணத்தின்ம திப்பீட்டாளர்",
    "notifications.person_state_has_been_changed": "நபர் நிலை மாற்றப்பட்டுள்ளது",
    "pageTitle.dashboard": "டாஷ்போர்டு",
    "moduleTitle.global_payment_method": "உலகளாவிய கட்டண முறை",
    "label.organization_type": "அமைப்பு வகை",
    "button.account_settings": "கணக்கு அமைப்புகள்",
    "notifications.contact_has_been_updated": "தொடர்பு புதுப்பிக்கப்பட்டது",
    "participant.recover_password": "கடவுச்சொல்லை மீட்கவும்",
    "notifications.assessment_request_has_been_sent": "மதிப்பீட்டு கோரிக்கை அனுப்பப்பட்டது",
    "button.unassign": "",
    "label.start_date": "தொடக்க தேதி",
    "label.assign_labels": "",
    "sidebar.participants": "பங்கேற்பாளர்கள்",
    "roles.coordinator": "ஒருங்கிணைப்பாளர்",
    "label.organization_contact": "அமைப்பு தொடர்பு",
    "tabs.customization": "தன்விருப்பமாக்குதல்",
    "sidebar.award_units": "விருது அலகுகள்",
    "button.change_goal": "இலக்கை மாற்றவும்",
    "translationsManagement.selectProject": "translationsManagement.selectProject",
    "award.rp": "ரெசிடென்ஷியல் ப்ராஜெக்ட்",
    "label.size": "அளவு",
    "label.bulk_action_results": "",
    "notifications.activity_has_been_approved": "செயல்பாடு ஏற்றுக்கொள்ளப்பட்டது",
    "label.payment_type": "",
    "button.gop_assignment": "",
    "button.resend_assessment_request": "மதிப்பீட்டு கோரிக்கையை மீண்டும் அனுப்புக",
    "notifications.template_has_been_removed": "டெம்ப்ளேட் நீக்கப்பட்டது",
    "button.award_settings": "விருது அமைப்புகள்",
    "pageTitle.payment": "பண வழங்கீடு",
    "tasks.return_award": "விருது மறுபரிசீலனை",
    "label.link": "இணைப்பு",
    "moduleTitle.award_participant_delete": "",
    "pageTitle.mro_related_contacts": "எனது பிராந்தியம் அலுவலகம் - தொடர்புடைய தொடர்புகள்",
    "pageTitle.my_organization_labels": "",
    "tabs.activity_signoff": "பிரிவு உள்நுழைவு",
    "table.logs": "பதிவுகள்",
    "moduleTitle.remove_file": "கோப்பை நீக்கவா?",
    "label.email_confirmed": "மின்னஞ்சல் உறுதிசெய்யப்பட்டது",
    "notifications.activity_has_been_returned": "செயல்பாடு திருத்தப்பட்டது",
    "label.note": "குறிப்பு",
    "button.show": "",
    "tabs.adventurous_journey": "சாகச பயணம்",
    "sidebar.my_todolist": "",
    "label.here": "இங்கே",
    "organisation.change_award_mode": "விருதுகள் முறை மாற்ற",
    "table.note_from_al": "விருதுத் தலைவரிடமிருந்து குறிப்பு",
    "label.gender": "பாலினம்",
    "moduleTitle.remove": "அகற்ற வேண்டுமா?",
    "errors.must_be_less_than": "{limit} விட குறைவாக இருக்க வேண்டும்",
    "button.logout": "வெளியேறு",
    "label.no_selected_participants": "தேர்ந்தெடுத்த பங்கேற்பாளர்கள் இல்லை",
    "button.new_aj_event": "புதிய சாகச பயண நிகழ்வு",
    "label.employement_status": "பணி நிலை",
    "tabs.logs": "பதிவுகள்",
    "tabs.contacts": "தொடர்புகள்",
    "label.option": "விருப்பம்",
    "dashboard.charts": "விளக்கப்படங்கள்",
    "notifications.rp_has_been_approved": "ரெசிடென்ஷியல் ப்ராஜெக்ட் அங்கீகரிக்கப்பட்டுள்ளது",
    "pageTitle.new_participant": "புதிய பங்கெடுப்பாளர்கள்",
    "notifications.award_leader_has_been_approved": "விருதுத் தலைவர் அங்கீகரிக்கப்பட்டுள்ளார்",
    "moduleTitle.would_you_like_to_remove_leader_training": "விருது பெற்ற தலைவர்களின் பயிற்சியை நீக்க விரும்புகிறீர்களா?",
    "moduleTitle.update_configuration_value": "கட்டமைப்பு மதிப்பு புதுப்பிக்கவும்",
    "table.description": "விளக்கம்",
    "table.organization": "அமைப்பு",
    "label.youtube": "யூ டூப்",
    "label.author": "எழுதியோன்",
    "table.suitable_for_award_level": "விருது நிலைக்கு பொருத்தமானது",
    "label.content_update": "காத்திருக்கவும். உள்ளடக்கத்தை மேம்படுத்துகிறது ...",
    "notifications.new_question_has_been_added": "புதிய கேள்வி சேர்க்கப்பட்டது",
    "pageTitle.nao_awards": "தேசிய அலுவலகம் - விருதுகள்",
    "table.last_name": "கடைசி பெயர்",
    "moduleTitle.adventurous_journey_detail": "பயண விவரங்கள்",
    "Description of the combo box selection in bulk operation panel": {"label.bulk_operations": ""},
    "label.project_location_type": "திட்ட இருப்பிட வகை",
    "label.email_help_award_level": "",
    "label.date": "தேதி",
    "label.previous_completed_award_place": "எங்கே",
    "button.show_more": "மேலும் காட்டு",
    "label.wwc_number": "WWC எண்",
    "button.filter": "வடிகட்டி",
    "notifications.rp_has_been_returned": "ரெசிடென்ஷியல் ப்ராஜெக்ட் புதுப்பிக்கப்பட்டுள்ளது",
    "pageTitle.residetial_project_assessor_report": "குடியிருப்பு திட்டம் - மதிப்பீட்டாளர் அறிக்கை",
    "label.generating": "உருவாக்கப்படுகிறது ...",
    "moduleTitle.finance_system_data": "நிதி அமைப்பு தரவு",
    "notifications.adventurous_journey_state_has_been_changed": "சாகச பயணத்தின் நிலை மாற்றப்பட்டுள்ளன",
    "route.levels": "நிலைகள்",
    "moduleTitle.activity_leader": "நடவடிக்கை தலைவர்",
    "tasks.approve_event": "நிகழ்வு ஒப்புதல்",
    "tasks.reject_event": "நிகழ்வு மறுபரிசீலனை",
    "table.region": "பகுதி",
    "pageTitle.nao_award_leaders": "தேசிய அலுவலகம் -விருது தலைவர்கள்",
    "errors.must_be_at_least": "குறைந்தது {min} எழுத்துகள் இருக்க வேண்டும்",
    "table.title": "தலைப்பு",
    "table.last_activity": "கடந்த செயல்பாடு",
    "tasks.delete_registration": "பதிவு நீக்கு",
    "table.date_time": "தேதி / நேரம்",
    "parentalConsent.the_award_operators_are_committed_to_respecting": "14. உங்களுடைய தனியுரிமைக்கு மரியாதை செலுத்துவதற்கு விருதுகள் வழங்கப்படுகின்றன. விருது பெறும் நோக்கத்திற்காக இந்தத் தகவலில் தனிப்பட்ட தகவல்கள் சேகரிக்கப்படுகின்றன. எங்களுக்கு இந்த தகவலை வழங்காத பங்கேற்பாளர்கள் விருதுக்கு பங்கேற்க முடியாது (இது பங்கேற்பாளர் தரவின் விதிமுறைகளுக்கு இது பொருந்தாது என்பதை நினைவில் கொள்ளவும்). உங்களிடமிருந்து உங்களுக்கு ஆர்வமாக இருக்கும் என்று நாங்கள் நம்பியிருக்கும் பிற விருதுகள் அல்லது நிகழ்வுகள் பற்றிய தகவலை அனுப்ப உங்கள் தனிப்பட்ட தகவலை நாங்கள் பயன்படுத்தலாம். இந்தத் தகவலின் செயல்பாடு மற்றும் நிர்வாகத்தில் எங்களுக்கு உதவி செய்யும் மற்ற உள்ளூர் அல்லது சர்வதேச நிறுவனங்கள் மற்றும் சேவை வழங்குநர்களுக்கு இந்த தகவலை நாங்கள் வெளியிடலாம். நீங்கள் எங்களை தொடர்பு கொள்ள அல்லது உங்கள் தனிப்பட்ட தகவல்களை அணுக விரும்பினால், தயவுசெய்து விருது ஆபரேட்டருக்கு எழுதுங்கள். அவற்றின் தனியுரிமைக் கொள்கையின் நகலைக் கோர, நீங்கள் விருது ஆபரேட்டரைத் தொடர்பு கொள்ளலாம்.",
    "aj.practice_journey": "பயிற்சி பயணம்",
    "notification.log_has_been_restored": "செயல்பாட்டு பதிவு மீட்டமைக்கப்பட்டது",
    "tabs.my_participants": "என் பங்கேற்பாளர்கள்",
    "label.bulk_action_assign_label": "",
    "moduleTitle.supervisor": "மேற்பார்வையாளர்",
    "moduleTitle.your_parental_consent": "உங்கள் பெற்றோர் ஒப்புதல்",
    "route.registration_participants": "பதிவு பங்கேற்பாளர்கள்",
    "placeholder.start_typing": "தட்டச்சு செய்யத் தொடங்குங்கள் ...",
    "tasks.approve_award": "விருது வழங்கவும்",
    "route.registrations": "பதிவுகள்",
    "button.add_activity": "",
    "notifications.aj_event_has_been_created": "சாகச பயண நிகழ்வு உருவாக்கப்பட்டது",
    "states.supervisor_approval": "மதிப்பீட்டாளரின் ஒப்புதல்",
    "label.description": "விளக்கம்",
    "button.leave_anyway": "எப்படியும் விடு",
    "tabs.registrations": "பதிவுகள்",
    "states.leader_signoff": "",
    "moduleTitle.forbidden": "",
    "notifications.translations_has_been_updated.button": "notifications.translations_has_been_updated.button",
    "pageTitle.nao_registration": "தேசிய அலுவலகம் - பதிவு",
    "pageTitle.mro_logs": "எனது பிராந்திய அலுவலகம் - பதிவுகள்",
    "meta.page_not_found": "பக்கம் காணப்படவில்லை",
    "label.bulk_action_unsuccessful": "",
    "global.days": "நாட்கள்",
    "table.review": "மதிப்பாய்வுரை",
    "table.as_assessor_for": "மதிப்பீட்டாளர்க்காக",
    "roles.if_staff_statistical_user": "IF புள்ளிவிவர பயனர்",
    "table.levels": "நிலைகள்",
    "label.suitable_for_level": "நிலைக்கு ஏற்றது",
    "pageTitle.leaders": "தலைவர்கள்",
    "moduleTitle.send_test_email": "டெஸ்ட் மின்னஞ்சல் அனுப்பு",
    "pageTitle.tasks_removed_registration": "பங்கேற்பாளர் பதிவு நீக்கப்பட்டது",
    "label.you_will_be_forced_to_login_again_after_change": "மாற்றத்திற்குப் பிறகு நீங்கள் உள்நுழைய வேண்டிய கட்டாயத்தில் உள்ளீர்கள்",
    "table.recent_updates": "",
    "pageTitle.tasks_activity_signoffs": "பிரிவு உள்நுழைவு",
    "pageTitle.payments": "பண வழங்கீடு",
    "global.nights": "இரவுகள்",
    "label.blank_any_level": "",
    "button.view_section": "",
    "moduleTitle.select_organization": "நிறுவனத்தைத் தேர்ந்தெடுக்கவும்",
    "pageTitle.manual_data_import": "",
    "button.upload_files": "கோப்புகளை பதிவேற்றவும்",
    "label.migrated_contact_email": "நகர்த்தப்பட்ட தொடர்புகொள்ளும் மின்னஞ்சல் முகவரி",
    "label.for_award_unit": "விருதுப் பிரிவுக்காக",
    "label.aj_template_note": "டெம்ப்ளேட் குறிப்பு",
    "table.last_log_added": "",
    "button.view_participant": "",
    "label.please_comment_on_the_participants": "பங்கேற்பாளர்களின் முன்னேற்றம் / செயல்திறன் / பொறுப்பு ஆகியவற்றில் கருத்து தெரிவிக்கவும்",
    "label.consent_already_given_login": "ஏற்கெனவே ஒப்புதல் வழங்கப்பட்டது. தயவுசெய்து உங்கள் குழந்தைக்கு உள்நுழைக.",
    "participant.level_start_date": "{value} தொடக்க தேதி",
    "sidebar.my_region_office": "எனது பிராந்திய அலுவலகம்",
    "states.section_signoff": "பிரிவு உள்நுழைவு",
    "moduleTitle.assessor_details": "மதிப்பீட்டாளரின் விவரங்கள்",
    "moduleTitle.adventurous_journey_settings": "சாகச பயண அமைப்புகள்",
    "moduleTitle.note_from_al": "விருதுத் தலைவரிடமிருந்து குறிப்பு",
    "button.add_role": "பங்கு சேர்க்க",
    "table.run": "ஓட்டம்",
    "states.change_to_state_warning_missing_assessment": "",
    "label.user_app_guide_leader": "பயனர் பயன்பாட்டு வழிகாட்டி - விருதுத் தலைவர்",
    "tabs.section_approval": "பிரிவு ஒப்புதல்",
    "roles.award_verifier": "விருது சரிபார்ப்பு",
    "tabs.activity_approval": "செயல்பாட்டு ஒப்புதல்",
    "logs.add_log": "பதிவு சேர்க்கவும்",
    "tabs.award": "விருது",
    "notifications.this_role_has_read_only_persmission": "இந்த பாத்திரம் படிக்க மட்டும் அனுமதி உள்ளது",
    "table.no_filtered_results": "வடிகட்டப்பட்ட முடிவுகள் இல்லை",
    "button.praise": "",
    "label.prevent_welcome_email_assessor": "",
    "label.location_detail": "இட விவரங்கள்",
    "label.optional": "(optional)",
    "errors.do_not_match": "பொருந்தவில்லை",
    "label.use_comma_for_multiple_entries": "பல உள்ளீடுகளுக்கு கமா பயன்படுத்தவும்",
    "label.operating_authority": "இயக்க ஆணையம்",
    "label.activity_section": "நடவடிக்கை பிரிவு",
    "notifications.you_have_been_logged_out": "நீங்கள் வெளியேற்றப்பட்டுள்ளீர்கள்",
    "table.finished": "முடிந்தது",
    "button.same_as_billing": "பில்லிங் போலவே",
    "table.payment": "பண வழங்கீடு",
    "table.current_level": "தற்போதைய நிலை",
    "button.view_nao": "",
    "table.email_confirmation": "மின்னஞ்சல் உறுதிப்படுத்தல்",
    "moduleTitle.shipping_address": "சேரும் முகவரி",
    "label.secondary_phone_type": "இரண்டாம் நிலை வகை",
    "notifications.saved": "சேமித்த",
    "pageTitle.all_participants": "சகல பங்கெடுப்பாளர்கள்",
    "label.first_name": "முதல் பெயர்",
    "label.oa_price": "OA விலை",
    "table.award_mode": "விருது முறை",
    "tabs.api_keys": "",
    "award.award_detail": "விருது விவரங்கள்",
    "tabs.user_management": "பயனர் மேலாண்மை",
    "tabs.all_events": "அனைத்து நிகழ்வுகள்",
    "notifications.history_record_has_been_removed": "வரலாற்றின் வரலாறு அகற்றப்பட்டது",
    "award.no_data": "தகவல் இல்லை",
    "notifications.preparation_training_has_been_added": "தயாரிப்பு மற்றும் பயிற்சி சேர்க்கப்பட்டுள்ளது",
    "label.message": "செய்தி",
    "notifications.participant_info_updated": "பங்கேற்பாளர் தகவல் புதுப்பிக்கப்பட்டது",
    "roles.nao_staff": "NAO பணியாளர்கள்",
    "tabs.adventurous_journeys": "சாகச பயணங்கள்",
    "label.gops": "",
    "route.upload": "பதிவேற்றம்",
    "notifications.history_record_has_been_added": "வரலாற்றின் பதிவு சேர்க்கப்பட்டது",
    "notifications.history_record_has_been_updated": "வரலாறு பதிவு புதுப்பிக்கப்பட்டது",
    "label.no_data": "தகவல் இல்லை",
    "button.add_coordinator": "ஒருங்கிணைப்பாளர் சேர்க்கவும்",
    "label.you_are_already_logged_as": "நீங்கள் ஏற்கனவே உள்நுழைந்துள்ளீர்கள்",
    "route.my_national_office": "என் தேசிய அலுவலகம்",
    "tabs.leaders": "தலைவர்கள்",
    "label.email_confirmation": "மின்னஞ்சல் உறுதிப்படுத்தல்",
    "table.registration_date": "பதிவு தேதி",
    "notifications.role_has_been_removed": "பங்கு அகற்றப்பட்டது",
    "button.move": "நகர்த்து",
    "label.terms_and_conditions": "",
    "pageTitle.detail": "விவரங்கள்",
    "table.award_unit": "விருதுப் பிரிவு",
    "sidebar.settings": "அமைப்புகள்",
    "dashboard.leader_state": "தலைவர்கள் - மாநிலம்",
    "notifications.award_unit_has_been_approved": "விருது பிரிவு அங்கீகரிக்கப்பட்டுள்ளது",
    "states.awaiting_approval": "ஒப்புதலுக்காக காத்திருக்கிறது",
    "table.level": "நிலை",
    "table.action_requested": "",
    "label.organisation_mode": "அமைப்பு முறை",
    "label.no_note": "குறிப்பு இல்லை",
    "tabs.my_events": "என் நிகழ்வுகள்",
    "notifications.participants_have_been_added": "பங்கேற்பாளர்கள் சேர்க்கப்பட்டுள்ளனர்",
    "tabs.registration_questions": "",
    "button.delete_registration": "பதிவு நீக்கு",
    "notifications.parental_consent_link_has_been_sent": "பெற்றோர் ஒப்புதல் இணைப்பு அனுப்பப்பட்டது",
    "moduleTitle.select_role_organization": "பங்கு & அமைப்பைத் தேர்ந்தெடுக்கவும்",
    "label.experience": "அனுபவம்",
    "translationsManagement.modal.title": "translationsManagement.modal.title",
    "table.ic": "சுதந்திர நாடுகள்",
    "table.id": "ஐடி\n",
    "label.notify_email_explanation": "",
    "participant.would_you_like_to_remove": "இந்த கணக்கை நீக்க விரும்புகிறீர்களா?",
    "table.fields_included": "",
    "label.user_guide_web_leader": "பயனர் இணையதளம் வழிகாட்டி - விருதுத் தலைவர்",
    "label.journey_type": "பயணத்தின் வகை",
    "button.setup": "அமைப்பு",
    "tabs.my_national_office": "என் தேசிய அலுவலகம்",
    "notifications.training_has_been_removed": "பயிற்சி நீக்கப்பட்டது",
    "label.nominated_and_identified_persons": "அனைத்து தரவையும் பார்வையிட ஆனால் திருத்த முடியாது என்று பரிந்துரைக்கப்பட்ட மற்றும் அடையாளம் காணப்பட்ட நபர்கள்",
    "moduleTitle.you_have_been_logged_out_due_to_inactivity": "செயலற்ற நிலை காரணமாக நீ வெளியேற்றப்பட்டாய்",
    "states.award_leader_signoff": "விருதுகள் தலைவர் கையெழுத்திடு",
    "table.award_signoff_attempts": "விருது வழங்கல் முயற்சிகள்",
    "sidebar.regions": "பகுதிகள்",
    "label.activity_deleted_note": "இந்த செயல்பாடு நீக்கப்பட்டது. கீழே உள்ள பொத்தானைக் கிளிக் செய்வதன் மூலம் அதை மீட்டெடுக்கலாம்.",
    "table.total": "மொத்தம்",
    "errors.a_problem_has_occured_during_processing": "செயலாக்கத்தின் போது ஒரு சிக்கல் ஏற்பட்டது, மேலும் தகவலைப் பார்க்கவும்",
    "participant.participant_already_has_gold_award": "பங்குதாரருக்கு ஏற்கனவே தங்க விருது வழங்கப்பட்டுள்ளது",
    "pageTitle.mro": "எனது பிராந்திய அலுவலகம்",
    "notifications.authorization_code_has_expired": "அங்கீகாரக் குறியீடு காலாவதியானது",
    "moduleTitle.child_organization_labels": "",
    "aj.aj_events": "சாகச பயணம் நிகழ்வுகள்",
    "global.loading": "ஏற்றுதல்",
    "label.gnipp": "GNIPP",
    "sidebar.registrations": "பதிவுகள்",
    "label.any_string": "எந்த சரம்",
    "contact.change_contact_status": "தொடர்பு நிலைமை மாற்றவும்",
    "tabs.registration": "பதிவு",
    "label.override_payment_note": "கட்டண குறிப்பை ரத்து செய்",
    "notifications.section_has_been_signed_off": "பிரிவினுள் நுழையப்பட்டது",
    "label.payment_date": "பண வழங்கீடு தேதி",
    "button.approve": "ஒப்புதல்",
    "moduleTitle.loggin_in": "உள்நுழைதல்",
    "label.website": "இணையதளம்",
    "label.role": "பங்கு",
    "table.assessor_report": "மதிப்பீட்டாளர் அறிக்கை",
    "label.ue_fe": "",
    "label.please_comment_on_the_participants_effort": "",
    "label.previously_worked_as_assessor": "முன்னர் மதிப்பீட்டாளராக பணிபுரிந்தார்",
    "pageTitle.registrations": "பதிவுகள்",
    "parentalConsent.this_form_must_be_completed": "",
    "button.apply": "",
    "errors.include_at_least_one_number": "குறைந்தபட்சம் ஒரு எண் எழுத்துக்குறியை சேர்க்கவும்",
    "label.content_restore": "அமர்வு புதுப்பிக்கிறது ...",
    "logs.hour": "மணி",
    "parentalConsent.i_have_read_and_understand": "7. அவுட்லைன் ஆஃப் தி அவார்ட் (இந்த வடிவத்தின் பக்கம் 5) இல் வழங்கப்பட்டபடி பல்வேறு தரநிலைகள் மற்றும் அவசியத்தின் தேவைகளை நான் படித்து புரிந்து கொண்டேன்.",
    "notifications.award_was_deleted": "",
    "label.journey_category": "பயணத்தை வகுப்பு",
    "notifications.search_cancelled": "தேடல் குறுக்கீடு செய்யப்பட்டது, நீங்கள் தேடல் முடிய காத்திருக்க வேண்டும்.",
    "route.detail": "விவரம்",
    "route.user_guide": "பயனர் வழிகாட்டி",
    "moduleTitle.history": "வரலாறு",
    "table.gop_name": "",
    "pageTitle.tasks_unassigned_participants": "ஒதுக்கப்படாத பங்கேற்பாளர்கள்",
    "states.inactive": "செயலற்ற",
    "pageTitle.search_results": "தேடல் முடிவுகள்",
    "button.proceed_to_login": "உள்நுழைவுக்கு தொடரவும்",
    "pageTitle.assessor_report_reject": "மதிப்பாய்வாளர் அறிக்கை திருத்தப்பட்டது",
    "notifications.contact_has_been_removed": "தொடர்பு நீக்கப்பட்டது",
    "sidebar.operating_authorities": "இயக்க அதிகாரங்கள்",
    "label.no_note_from_participant": "",
    "aj.preparation_and_training": "தயாரிப்பு மற்றும் பயிற்சி",
    "route.user_guide_web_leader": "பயனர் இணையதளம் வழிகாட்டி - விருதுத் தலைவர்",
    "label.position_in_organization": "நிறுவனத்தில் நிலை",
    "errors.emails_dont_match": "மின்னஞ்சல் பொருந்தவில்லை",
    "route.my_participants": "என் பங்கேற்பாளர்கள்",
    "pageTitle.customisations": "தன்விருப்பமாக்குதல்",
    "tabs.localization_files": "உள்ளூராக்கல் கோப்புகள்",
    "table.assessor_approval": "மதிப்பீட்டாளர் ஒப்புதல்",
    "tabs.related_contacts": "தொடர்புடைய தொடர்புகள்",
    "table.aus": "விருது அலகுகள்",
    "table.category": "",
    "errors.file_is_too_large": "",
    "label.possible_values": "சாத்தியமான மதிப்புகள்:",
    "label.if_your_download_doesnt_start": "உங்கள் பதிவிறக்க தானாக இயங்கவில்லையெனில் தயவுசெய்து இங்கே கிளிக் செய்யவும்",
    "route.independent_award_centres": "சுதந்திர விருது மையங்கள்",
    "pageTitle.user_guide": "பயனர் வழிகாட்டிகள்",
    "button.visit": "",
    "label.hours_first_letter": "h",
    "pageTitle.my_organization_detail": "என் அமைப்பு - விவரங்கள்",
    "pageTitle.nao_detail": "தேசிய அலுவலகம் - விபரங்கள்",
    "button.change": "மாற்றம்",
    "award.aj": "சாகச பயணம்",
    "table.award_state": "விருது நிலை",
    "pageTitle.tasks_award_signoff": "விருது உள்நுழைவு",
    "pageTitle.regions": "பகுதிகள்",
    "notifications.award_has_been_signed_off": "விருது கையொப்பமிடப்பட்டது",
    "dashboard.award_approved_by": "விருதுகள் அங்கீகரிக்கப்பட்ட - 2016 அளவில்",
    "tabs.new_template": "புதிய டெம்ப்ளேட்",
    "error.parent_email_must_be_filled": "பெற்றோர் மின்னஞ்சல் நிரப்பப்பட வேண்டும்",
    "label.organisation_invoicing_name": "அமைப்பு விலைப்பட்டியல் பெயர்",
    "pageTitle.related_contacts": "தொடர்புடைய தொடர்புகள்",
    "button.try_again": "எச்சரிக்கையை மூடி, மீண்டும் முயற்சிக்கவும்",
    "label.cannot_be_change_to_another": "மற்றொரு விருது நிலைக்கு மாற்ற முடியாது",
    "notifications.lead_coordinator_has_been_set": "புதிய முன்னணி ஒருங்கிணைப்பாளர் அமைக்கப்பட்டுள்ளது",
    "label.training_name": "பயிற்சி பெயர்",
    "moduleTitle.new_contact": "புதிய தொடர்பு",
    "translationsManagement.modal.updateTitle": "translationsManagement.modal.updateTitle",
    "moduleTitle.offline_award_units_signoff": "ஆஃப்லைன் விருதுகள் தலைவர் கையெழுத்து",
    "notifications.award_level_has_been_changed": "விருது நிலை மாற்றப்பட்டது",
    "label.subject": "பொருள்",
    "route.silver_level": "வெள்ளி நிலை",
    "label.privacy_notice": "",
    "label.switch_organization": "அமைப்பு மாற",
    "meta.dofe_name": "டியூக் எடின்பர்க் இன் சர்வதேச விருது",
    "route.profile": "தோற்ற வடிவம்",
    "roles.super_user": "சூப்பர் பயனர்",
    "dashboard.while_you_were_gone": "நீ போயிருந்தபோது",
    "label.no_note_from_award_leader": "",
    "label.middle_name": "மத்திய பெயர்",
    "moduleTitle.new_activity": "புதிய செயல்பாடு",
    "organisation.would_you_like_to_remove": "இந்த அமைப்பை அகற்ற விரும்புகிறீர்களா?",
    "label.state_province": "மாநில / பிராந்தியம் / மண்டலம்",
    "moduleTitle.your_home_address": "உங்கள் வீட்டு முகவரி",
    "tabs.sign_offs": "உள்நுழைவு பரிமாற்றங்கள்",
    "moduleTitle.logs": "பதிவுகள்",
    "button.view_more": "மேலும் பார்க்க",
    "label.profile": "தோற்ற வடிவம்",
    "label.title": "தலைப்பு",
    "tabs.award_signoff": "விருது கையொப்பமிடல்",
    "label.post_code": "அஞ்சல் குறியீடு",
    "states.ceremony_certificate": "விழா",
    "label.code": "",
    "parentalConsent.i_consent_to_the_provision_of_any": "13. விருது வழங்கல் மற்றும் விருது வழங்குபவருக்கு நான் வழங்கிய தனிப்பட்ட தகவலின் (பங்கேற்பாளர் தரவு உட்பட) வழங்குவதற்கு நான் ஒப்புக்கொள்கிறேன். 1998 ஆம் ஆண்டு தரவு பாதுகாப்பு சட்டத்தில் (இங்கிலாந்து) உள்ள தேசிய தனியுரிமைக் கொள்கைகள் (அல்லது எந்தவொரு உள்ளூர் சமமான கொள்கையிலும் உள்ளடக்கப்பட்ட தேசிய விருதுகள்) அல்லது செயல்) மற்றும் தனியுரிமை சட்டத்தின் கீழ் வேறு தனியுரிமை சட்டங்கள், தரநிலைகள், வழிகாட்டு நெறிகள் அல்லது அறிவுறுத்தல்கள்.",
    "label.user_guide_web_participant": "பயனர் இணையதளம் வழிகாட்டி - பங்கேற்பாளர்",
    "label.award_unit_type": "விருது பிரிவு வகை",
    "states.complete": "",
    "table.participant_state": "பங்கேற்பாளர் நிலை",
    "pageTitle.my_organization_payment": "எனது அமைப்பு - பண வழங்கீடு",
    "table.approved": "அங்கீகரிக்கப்பட்டது",
    "pageTitle.my_organization_contacts": "எனது அமைப்பு- தொடர்புகள்",
    "warning.award_marked_as_paid_registration": "",
    "states.change_to_state": "",
    "label.integer": "முழு எண்",
    "notifications.translationUpdateInterrupted": "notifications.translationUpdateInterrupted",
    "notifications.password_has_been_changed": "கடவுச்சொல் மாற்றப்பட்டுள்ளது",
    "button.invite_assessor": "மதிப்பீட்டாளரை அழை",
    "label.other_activity": "பிற செயல்பாடு",
    "notifications.parental_consent_has_been_sent": "பெற்றோர் ஒப்புதல் அனுப்பப்பட்டது",
    "button.revise": "திருத்தியமைக்க",
    "errors.end_date_must_be_after_start_date": "கடைசி தேதி தொடக்க தேதிக்குப் பிறகு இருக்க வேண்டும்",
    "label.award_leader_signoff_date": "விருதுத் தலைவர் பதிவு தேதி",
    "parentalConsent.i_understand_every_participant_must": "8. ஒவ்வொரு பங்கேற்பாளரும் ஒரு விருதுப் பிரிவின் மூலம் விருதுக்கு பங்கேற்க வேண்டும், பங்கேற்பாளர்களை ஏற்றுக்கொள்ளவும், நிராகரிக்கவும் விருப்பம் உள்ளவராகவும், விருதுகள் வழங்கப்பட வேண்டும் என்று பரிந்துரைக்கப்பட வேண்டும்.",
    "moduleTitle.policies": "",
    "pageTitle.tasks_aj": "சாகச பயணம்",
    "global.day": "நாள்",
    "moduleTitle.coordinator": "ஒருங்கிணைப்பாளர்",
    "label.region": "பகுதி",
    "button.add_history_record": "வரலாற்றின் பதிவுகளைச் சேர்க்கவும்",
    "moduleTitle.adventurous_journey_template_settings": "சாகச பயண டெம்ப்ளேட் அமைப்புகள்",
    "notifications.personal_details_have_been_updated": "தனிப்பட்ட விவரங்கள் புதுப்பிக்கப்பட்டுள்ளன",
    "sidebar.ics": "சுதந்திர நாடுகள்",
    "table.independent_award_centre": "சுதந்திர விருது மையம்",
    "label.undelivered_mail_reason": "",
    "table.utc_date_time": "",
    "moduleTitle.emails": "மின்னஞ்சல்கள்",
    "label.backoffice": "label.backoffice",
    "moduleTitle.parent_consent": "பெற்றோர் / கார்டியன் ஒப்புதல்",
    "label.photo_consent_given": "விளம்பரத்திற்கான அவரது / அவள் சுயவிவர படத்தை நாம் பயன்படுத்தலாம் என்பதை ஒப்புக்கொள்கிறார்",
    "moduleTitle.authorising_contact": "தொடர்பு அங்கீகரித்தல்",
    "label.assessment_with_role": "{role} மதிப்பீடு",
    "dashboard.type_of_awards": "விருது பிரிவின் வகை",
    "moduleTitle.payment": "Payment\n",
    "states.in_progress": "முன்னேற்றம்",
    "logs.no_logs": "பதிவுகள் இல்லை",
    "sidebar.my_office": "என் அலுவலகம்",
    "label.assessor_report": "மதிப்பீட்டாளர் அறிக்கை",
    "notifications.rp_has_been_signed_off": "ரெசிடென்ஷியல் ப்ராஜெக்ட் கையெழுத்தானது",
    "tabs.labels": "",
    "sidebar.payments": "பண வழங்கீடு",
    "meta.profile_questions": "சுயவிவர கேள்விகள்",
    "label.fax": "ஃபாக்ஸ் (fax)",
    "label.email_help_custom_link": "",
    "label.last_name": "கடைசி பெயர்",
    "organisation.manage_gop": "",
    "table.parental_consent": "",
    "dashboard.participant_by_level": "பங்கேற்பாளர்கள் - நிலை மூலம்",
    "tabs.award_leaders": "விருது தலைவர்கள்",
    "label.i_confirm_that_ive_witnessed": "கீழே உள்ள செயல்களுக்கு பங்கேற்பாளர்கள் பதிவு புத்தகம் நான் பார்த்திருப்பதை உறுதிப்படுத்துகிறேன்",
    "table.lead_coordinator": "",
    "states.deleted": "நீக்கப்பட்டது",
    "label.no_answers": "பதில் இல்லை",
    "button.add": "சேர்",
    "label.exchequer_number": "Exchequer A/c No.",
    "label.waiting": "காத்திருக்கிறது",
    "label.email_help_person_full_name": "",
    "tasks.return_registration": "பதிவுசெய்தல் மறுபரிசீலனை",
    "notifications.state_aj_preparation_training_has_been_changed": "",
    "label.parent_approval": "பெற்றோர் ஒப்புதல்",
    "table.assessor_approve": "மதிப்பீட்டாளர் ஒப்புக்கொள்கிறார்",
    "errors.some_fields_requires_your_attention": "சில துறைகளில் உங்கள் கவனம் தேவை",
    "aj.qualifying_journey": "தகுதி பெரும் பயணம்",
    "route.awards": "விருதுகள்",
    "table.registration": "பதிவு",
    "pageTitle.assessors": "மதிப்பீட்டாளர்கள்",
    "notifications.award_has_been_updated": "விருது மேம்படுத்தப்பட்டது",
    "errors.must_be_one_of": "ஒன்று இருக்க வேண்டும்: {enums}",
    "pageTitle.logs": "பதிவுகள்",
    "notifications.notifications.invitation_has_been_sent": "அழைப்பிதழ் அனுப்பப்பட்டுள்ளது",
    "route.national_offices": "தேசிய அலுவலகங்கள்",
    "notifications.training_has_been_updated": "பயிற்சி மேம்படுத்தப்பட்டது",
    "label.parent_last_name": "பெற்றோர் / கார்டியன் கடைசிப் பெயர்",
    "table.leaders": "தலைவர்கள்",
    "states.award_level_complete": "விருது நிலை நிறைவடைந்தது",
    "button.reset": "மீட்டமை",
    "sidebar.my_award_unit": "என் விருது பிரிவு",
    "pageTitle.all_aj_events": "அணைத்து சாகச பயண நிகழ்வுகள்",
    "label.activity": "செயல்பாடு",
    "moduleTitle.are_you_sure": "நீ சொல்வது உறுதியா?",
    "route.gold_level": "தங்க நிலை",
    "table.evidence": "ஆதாரம்",
    "label.delivery_confirmed": "வழங்கல் உறுதிசெய்யப்பட்டது",
    "parentalConsent.as_the_parent": "பெற்றோர் / காப்பாளர், விளம்பர நோக்கங்களுக்காக அறக்கட்டளை பயன்படுத்த எந்த படங்களையும் நான் ஒப்புக்கொள்கிறேன்.",
    "label.awardMode.offline": "ஆஃப்லைன்",
    "tasks.approve_registration": "பதிவு அங்கீகரிக்கவும்",
    "note.change_the_email_will_change": "குறிப்பு: மின்னஞ்சலை மாற்றுதல், குடிபெயர்ந்த தொடர்பு மின்னஞ்சலை மாற்றும்",
    "notifications.participant_has_been_approved": "பங்கேற்பாளர் அங்கீகரிக்கப்பட்டுள்ளார்",
    "label.reached_activity_limit": "இந்த செயல்பாடு பிரிவில் நடவடிக்கைகள் வரம்பு எட்டப்பட்டது. ஒவ்வொரு பிரிவிலும் பங்குபெறும் அதிகபட்சம் 3 நடவடிக்கைகள் இருக்கலாம்.",
    "label.facebook": "முகநூல்",
    "notifications.label_has_been_removed": "",
    "label.action_required": "",
    "notifications.preparation_training_has_been_removed": "தயாரிப்பு மற்றும் பயிற்சி நீக்கப்பட்டது",
    "pageTitle.settings": "அமைப்புகள்",
    "participant.level_registration_date": "{value} பதிவு தேதி",
    "notifications.question_has_been_removed": "கேள்வி நீக்கப்பட்டது",
    "label.email_help_award_leader_full_name": "",
    "sidebar.leaders": "தலைவர்கள்",
    "notifications.participants_have_been_transferred": "பங்கேற்பாளர்கள் இடமாற்றம் செய்யப்பட்டுள்ளனர்",
    "tabs.assessors": "மதிப்பீட்டாளர்கள்",
    "sidebar.dashboard": "வலைத்தளம் டாஷ்போர்டு",
    "pageTitle.independent_award_centers": "சுதந்திர விருது மையங்கள்",
    "label.search": "தேடல்",
    "moduleTitle.office_labels": "",
    "label.note_from_participant": "பங்கேற்பாளரிடமிருந்து குறிப்பு",
    "errors.required_field": "தேவையான புலம்",
    "tasks.approve_task": "பணி ஒப்புதல்",
    "logs.edit_log": "பதிவினை திருத்தவும்",
    "table.state": "நிலை",
    "moduleTitle.level_summary": "",
    "moduleTitle.guides": "",
    "modal.close": "மூடு",
    "label.parent_first_name": "பெற்றோர் / கார்டியன் முதல் பெயர்",
    "parentalConsent.i_understand_that_the_participant": "1. இந்த படிவம் முடிக்கப்பட்டு (பெற்றோர் / பாதுகாவலர் ஒப்புதல் உட்பட) முடிவடையும் வரை பங்கேற்பாளர் பங்கேற்பாளரைப் பங்கேற்க முடியாது மற்றும் பொருந்தக்கூடிய பதிவுக் கட்டணத்துடன் தொடர்புடைய விருது வழங்குபவருடன் மீண்டும் வருகிறார், பின்னர் விருதுப் பிரிவில் ஏற்றுக்கொள்ளப்பட்டார்.",
    "tabs.award_units": "விருது அலகுகள்",
    "table.hours": "மணி நேரங்கள்",
    "label.type": "வகை",
    "notifications.adventurous_journey_has_been_removed": "சாகச பயணம் நீக்கப்பட்டது",
    "label.aj_is_not_approved_yet": "சாகச பயணம் இன்னும் அங்கீகரிக்கப்படவில்லை",
    "roles.authorizing_contact": "தொடர்பு அங்கீகரித்தல்",
    "table.date_submitted_to_office_signoff": "விருது அலுவலகம் கையெழுத்திட சமர்ப்பிக்கப்பட்ட தேதி",
    "notifications.section_has_been_returned": "பிரிவு திருத்தப்பட்டது",
    "table.created_by": "உருவாக்கப்பட்டது",
    "route.user_guide_web_participant": "பயனர் இணையதளம் வழிகாட்டி - பங்கேற்பாளர்",
    "route.templates": "டெம்ப்ளேட்கள்",
    "states.awaiting_sign_off": "விருதுகள் தலைவர் கையெழுத்திடு",
    "table.phone": "தொலைபேசி",
    "label.parental_consent": "பெற்றோர் ஒப்புதல்",
    "label.org_contact_will_be_deleted": "",
    "route.bronze_level": "வெண்கல நிலை",
    "label.invoice_currency": "விலைப்பட்டியல் நாணயம்",
    "button.new_label": "",
    "error.server_cannot_be_reached_at_the_moment": "தற்போது சேவையகத்தை எட்ட முடியவில்லை. தயவுசெய்து பின்னர் முயற்சிக்கவும். சிக்கல் தொடர்ந்தால், எங்கள் ஆதரவு குழுவைத் தொடர்புகொள்ளவும்.",
    "notifications.contact_has_been_created": "தொடர்பு உருவாக்கப்பட்டது",
    "pageTitle.profile_questions": "சுயவிவர கேள்விகள்",
    "table.observation_files": "கவனிப்பு கோப்புகள்",
    "table.participants": "பங்கேற்பாளர்கள்",
    "tasks.no_evidence": "எந்த ஆதாரமும் வழங்கப்படவில்லை",
    "button.edit": "தொகு",
    "moduleTitle.leader": "தலைவர்",
    "notifications.new_template_has_been_updated": "புதிய டெம்ப்ளேட் புதுப்பிக்கப்பட்டது",
    "table.name": "பெயர்",
    "label.no_results": "முடிவுகள் இல்லை",
    "moduleTitle.documents": "ஆவணங்கள்",
    "button.invite": "அழைக்கவும்",
    "label.goal": "நோக்கம்",
    "pageTitle.nao_award_units": "தேசிய அலுவலகம் -விருது பிரிவுகள்",
    "label.award_delete_participant_id": "",
    "errors.at_least_num_characters": "குறைந்தது {length} எழுத்துகள் நீண்ட",
    "label.email_help_note": "",
    "label.person_status.activating": "label.person_status.activatin",
    "moduleTitle.remove_role": "Remove role?",
    "label.total": "மொத்தம்",
    "label.delete_participant_award_info": "",
    "route.leaders": "தலைவர்கள்",
    "table.start_date": "தொடக்க தேதி",
    "moduleTitle.coordinators": "ஒருங்கிணைப்பாளர்கள்",
    "button.create": "உருவாக்கவும்",
    "tabs.awards": "விருதுகள்",
    "parentalConsent.form_has_been_sent": "பெற்றோர் ஒப்புதல் அனுப்பப்பட்டது.",
    "states.journey_approval": "பயணம் அங்கீகாரம்",
    "pageTitle.reports": "அறிக்கைகள்",
    "table.journey_type": "பயணத்தின் வகை",
    "label.yes": "ஆம்",
    "pageTitle.assessor_report": "மதிப்பீட்டாளர் அறிக்கை",
    "label.organization": "குழு",
    "notifications.award_leader_has_been_updated": "விருது தலைவர் புதுப்பிக்கப்பட்டது",
    "moduleTitle.edit_role": "பாத்திரம் திருத்தவும்",
    "table.journey_activity": "பயணத்தின் செயல்பாடு",
    "label.location": "இட அமைவு",
    "label.update_translations_error_item": "",
    "pageTitle.adventurous_journeys": "சாகச பயணங்கள்",
    "global.assessor": "மதிப்பீட்டாளர்",
    "moduleTitle.profile_questions": "சுயவிவர கேள்விகள்",
    "activity.cannot_edit_activity_if_award_in_state": "விருது {state} நிலையில் இருந்தால் செயல்பாடு திருத்த முடியாது",
    "moduleTitle.assessor_detail": "மதிப்பீட்டாளரின் விவரங்கள்",
    "parentalConsent.i_understand_that_upon_acceptance_into": "விருதுப் பிரிவின் விருதுக்கு ஏற்ப, பங்கேற்பாளர் பதிவுப் புத்தகத்தைப் பெறுவார் அல்லது ஆன்லைன் பதிவு புத்தகத்திற்கான அணுகல் (ORB) பெறுவார் என்று புரிந்துகொள்கிறேன். விருது தொடர்பாக நடவடிக்கைகளைத் தொடங்குவதற்கு முன்பாக பதிவுப் புத்தகத்தில் அல்லது ORB உள்ளிட்ட விருதுகளின் பங்கேற்பாளர் பங்கேற்பார் வாசிப்பார். விருது வழங்கல் தேவைகள் பூர்த்தி செய்யப்பட்டதா என்பதை தீர்மானிக்க, விருது வென்றது, எனவே வெண்கல, வெள்ளி அல்லது தங்க விருது வழங்கப்பட வேண்டுமா என்பதை நான் புரிந்துகொள்கிறேன். விருது ஆபரேட்டர் விருது பெற்ற பிரிவின் மூலம் விருதுக்கு விண்ணப்பிக்கும்போது தனிப்பட்ட விபத்து மற்றும் பொதுப் பொறுப்புக் காப்பீடு ஆகியவற்றில் பங்கேற்பாளர்களுக்கு மட்டுமல்லாமல், தனிப்பட்ட விபத்து மறைப்பைப் பெற்றுக் கொள்வதற்கான பொறுப்பும் பங்கேற்பாளர் / பெற்றோர் / பாதுகாவலர்.",
    "notifications.award_has_been_returned": "விருது திருத்தப்பட்டது",
    "label.code_of_conduct": "",
    "button.new_contact": "புதிய தொடர்பு",
    "tabs.payments": "பண வழங்கீடு",
    "roles.naa_oa_staff": "NAA OA பணியாளர்கள்",
    "label.switch_organisation_hint": "மேல் வலது மூலையில் உள்ள மெனுவில் 'ஸ்விட்ச் ஓர்கனைசேஷன்' தேர்ந்தெடுப்பதன் மூலம் எந்த நேரத்திலும் இந்த உரையாடலை திறக்க முடியும்",
    "label.expiration_date": "காலாவதி தேதி",
    "tabs.participants": "பங்கேற்பாளர்கள்",
    "table.practice": "பயிற்சி",
    "notifications.one_activity_has_to_remain": "பிரிவில் ஒரு செயல்பாடு செயலில் இருக்க வேண்டும்",
    "label.qualifications": "தகுதிகள்",
    "states.organization_approval": "விருது அலுவலகம் கையெழுத்து",
    "errors.must_be_an_integer": "ஒரு முழு எண்ணாக இருக்க வேண்டும்",
    "participant.send_confirmation_email_again_question": "உறுதிப்படுத்தல் மின்னஞ்சலை மீண்டும் அனுப்பவா?",
    "button.dismiss": "நிராகரி",
    "table.advice": "",
    "label.years_of_working_experience": "வேலை அனுபவம் ஆண்டுகள்",
    "notifications.search_failed": "தேடும் போது ஒரு பிழை ஏற்பட்டது. தயவுசெய்து பின்னர் முயற்சிக்கவும்.",
    "notifications.changes_have_been_saved": "மாற்றங்கள் சேமிக்கப்பட்டன",
    "moduleTitle.resend_parental_consent_link": "பெற்றோர் ஒப்புதல் இணைப்பை மீண்டும் அனுப்பவா?",
    "label.activity_type": "செயல்பாட்டு வகை",
    "label.change_award": "விருது நிலை மாற்ற",
    "label.email": "மின்னஞ்சல்",
    "button.remove": "நீக்கு",
    "button.download": "பதிவிறக்கம்",
    "label.vat_treatment": "VAT சிகிச்சை",
    "pageTitle.aj_template_new": "புதிய சாகச பயணத்தின் டெம்ப்ளேட்",
    "table.per_page": "பக்கம் ஒன்றுக்கு",
    "notifications.translations_has_been_updated": "notifications.translations_has_been_updated",
    "notification.award_mode_has_been_updated": "விருது முறை புதுப்பிக்கப்பட்டது",
    "tasks.revise_item": "பொருள் மறுபரிசீலனை",
    "button.resend_parental_consent": "பெற்றோர் அனுமதியை மீண்டும் அனுப்பு",
    "table.weeks_completed_required": "வாரங்கள் நிறைவடைந்தவை / தேவைபடுபவை",
    "label.last_modified": "கடைசியாக மாற்றப்பட்டது",
    "table.major": "பெரும்பான்மை",
    "label.vat_number": "VAT இல.",
    "errors.passwords_dont_match": "கடவுச்சொற்கள் பொருந்தவில்லை",
    "table.country": "நாடு",
    "sidebar.guides_and_policies": "",
    "notifications.question_has_been_updated": "கேள்வி புதுப்பிக்கப்பட்டது",
    "table.participant_name": "",
    "label.registration_approval_date": "",
    "notifications.auth_code_is_no_longer_valid": "அங்கீகாரம் குறியீடு இனி செல்லுபடியாகாது",
    "errors.must_be_no_more_than": "அதிகபட்சமாக {max} எழுத்துகள் இருக்க வேண்டும்",
    "notifications.event_has_been_rejected": "நிகழ்வு திருத்தப்பட்டது",
    "tabs.customizations": "தன்விருப்பமாக்குதல்",
    "label.name_organization": "பெயர்",
    "button.add_log": "பதிவு சேர்க்கவும்",
    "moduleTitle.invite_assessor": "மதிப்பீட்டாளரை அழை",
    "label.resend_confirmation_email": "",
    "text.all_participants_will_be_transfered": "அனைத்து பங்கேற்பாளர்களும் ஒரு புதிய விருது தலைவருக்கு மாற்றப்படுவார்",
    "label.repeat_email": "மின்னஞ்சல் மீண்டும் அனுப்பவும்",
    "errors.email_or_phone_required": "",
    "notifications.role_has_been_updated": "பங்கு புதுப்பிக்கப்பட்டது",
    "roles.if_staff_stat_user": "IF புள்ளிவிவர பயனர்",
    "participant.delete_account": "தொடர்பு நீக்கு",
    "moduleTitle.would_you_like_to_remove_this_log": "இந்த பதிவை நீக்க விரும்புகிறீர்களா?",
    "sidebar.sgops": "",
    "label.prepare_new_email": "",
    "table.journey_category": "பயணத்தின் வகை",
    "sidebar.manual_data_import": "கையேடு தரவு இறக்குமதி",
    "label.created_after_date": "பிறகு உருவாக்கப்பட்டது",
    "route.my_organization": "என் அமைப்பு",
    "button.show_list": "",
    "label.leaders": "தலைவர்கள்",
    "notifications.log_has_been_modified": "பதிவு மாற்றப்பட்டுள்ளது",
    "button.upload_file": "கோப்பு பதிவேற்றவும்",
    "moduleTitle.which_section_do_you_want_to": "நீங்கள் 'முன்னேற்றத்தில்' மீண்டும் எந்த பிரிவை விரும்புகிறீர்கள்?",
    "tabs.bronze_level": "வெண்கல நிலை",
    "notifications.participants_have_been_saved": "பங்கேற்பாளர்கள் சேமிக்கப்பட்டுள்ளனர்",
    "pageTitle.aj_template_detail": "சாகச பயணம்",
    "label.parent_email": "பெற்றோரின் / கார்டியன் மின்னஞ்சல்",
    "map.appr_location": "தோராயமான முகவரி:",
    "notifications.log_has_been_removed": "பதிவு அகற்றப்பட்டது",
    "notifications.label_has_been_assigned": "",
    "pageTitle.tasks_undelivered_emails": "",
    "button.stay": "தங்க",
    "table.previous_level": "முந்தைய நிலை",
    "label.award_start_date": "விருது தொடக்க தேதி",
    "assessor_report.returned_to_participant": "பங்கேற்பாளரிடம் திருப்பப்பட்டது",
    "pageTitle.tasks_assessors_registration": "மதிப்பீட்டாளரின் பதிவு",
    "aj.cannot_modify_award": "பங்கேற்பாளர்கள் சாகச பயணத்திற்கு ஒதுக்கப்பட்டுள்ளால், விருது நிலை திருத்த முடியாது",
    "moduleTitle.lost_internet_connection": "இணைய இணைப்பை இழந்ததைப் போல் தெரிகிறது",
    "states.ceremony": "விழா",
    "participant.reactivate_account": "அக்கௌன்ட் ஐ மீண்டும் செயல்படுத்தவும்",
    "label.birthdate": "பிறந்த தேதி",
    "pageTitle.assessment_send_successfully": "மதிப்பீடு வெற்றிகரமாக அனுப்பப்பட்டது",
    "states.assessor_approval": "மதிப்பீட்டாளர் ஒப்புதல்",
    "award.change_award_level": "விருது நிலை மாற்ற",
    "label.url_no_longer_valid": "இந்த URL இனி செல்லுபடியாகாது.",
    "button.update": "புதுப்பிக்கப்பட்டது",
    "label.secondary_email": "இரண்டாம் நிலை மின்னஞ்சல்",
    "button.role_edit": "தொகுத்து அமை",
    "table.award_leader": "விருதுத் தலைவர்",
    "label.level": "நிலை",
    "tasks.evidence": "ஆதாரம்",
    "notifications.participant_is_already_in_list": "பங்கேற்பாளர் ஏற்கனவே பட்டியலில் உள்ளார்",
    "button.clear": "தெளிவு",
    "label.allow_log_after_25_yoa": "",
    "states.setup": "அமைப்பு",
    "table.activity": "செயல்பாடு",
    "label.copy_to_clipboard": "",
    "route.award_units": "விருது அலகுகள்",
    "button.upload_photo": "படத்தை பதிவேற்றவும்",
    "table.hours_completed_required": "மணி நேரம் நிறைவு / தேவை",
    "table.first_name": "முதல் பெயர்",
    "notifications.adventurous_journey_has_been_returned": "சாகச பயணம் திருத்தப்பட்டது",
    "pageTitle.national_offices": "தேசிய அலுவலகங்கள்",
    "notifications.you_have_been_logged_in": "நீங்கள் உள்நுழைந்துள்ளீர்கள்",
    "logs.offline": "",
    "moduleTitle.add_role": "பங்கைச் சேர்க்கவும்",
    "label.user_app_guide_participant": "பயனர் பயன்பாட்டு வழிகாட்டி - பங்கேற்பாளர்",
    "notifications.file_has_been_removed": "கோப்பு அகற்றப்பட்டது",
    "label.send_message": "",
    "button.select": "தேர்ந்தெடு",
    "label.reason_of_deletion": "நீக்குவதற்கான காரணம்",
    "label.user_guide": "பயனர் வழிகாட்டி",
    "pageTitle.nao_participants": "தேசிய அலுவலகம் -விருது பங்கெடுப்பாளர்கள்",
    "tabs.sub_operating_partners": "",
    "table.uploaded_by": "பதிவேற்றியது",
    "tasks.approve_item": "பொருள் ஒப்புதல்",
    "tasks.restore_participant_registration": "பங்கேற்பாளர் பதிவுகளை மீட்டமைக்கவா?",
    "label.awardMode.hybrid": "ஹைபிரிட்",
    "table.first_activity_started": "முதல் செயல்பாடு தொடங்கியது",
    "moduleTitle.dates": "தேதிகள்",
    "table.no_results": "முடிவுகள் இல்லை",
    "states.registration_approval": "பதிவு ஒப்புதல்",
    "table.breakdown_of_hours": "மணிநேர முறிவு",
    "pageTitle.tasks_registration": "பங்கெடுப்பாளர் பதிவு",
    "button.create_new": "புதிதாக உருவாக்கு",
    "sidebar.todolist": "பட்டியல் செய்ய",
    "label.active_participants": "சுறுசுறுப்பான பங்கேற்பாளர்கள்",
    "moduleTitle.postalAddress": "moduleTitle.postalAddress",
    "tasks.return_task": "பணி மறுபரிசீலனை",
    "organisation.change_organisation_state": "அமைப்பின் நிலையை மாற்றவும்",
    "moduleTitle.roles": "பாத்திரங்கள்",
    "label.no_config_key_available": "இந்த பிரிவிற்கு கட்டமைப்பு விசை இல்லை",
    "placeholder.selectLanguage": "placeholder.selectLanguage",
    "states.office_signoff": "விருது அலுவலகம் கையெழுத்து",
    "notifications.translations_has_been_updated.failure": "notifications.translations_has_been_updated.failure",
    "logs.minute": "நிமிடம்",
    "label.last_activity": "கடந்த செயல்பாடு",
    "sidebar.user_guide": "பயனர் வழிகாட்டிகள்",
    "label.trained_award_leader": "ஒரு பயிற்சி பெற்ற விருதுத் தலைவர்",
    "table.progress": "முன்னேற்றம்",
    "table.suboperating_authorities": "துணை இயக்க அதிகாரங்கள்",
    "activity.cannot_edit_activity_offline": "",
    "label.user_does_not_have_permissions": "",
    "notifications.assessor_has_been_approved": "மதிப்பீட்டாளர் அங்கீகரிக்கப்பட்டுள்ளார்",
    "route.activity_approval": "செயல்பாட்டு ஒப்புதல்",
    "moduleTitle.role": "பங்கு",
    "button.run": "ஓட்டம்",
    "label.to": "பெறுநர்",
    "notifications.file_has_been_updated": "கோப்பு பதிவேற்றப்பட்டது",
    "moduleTitle.edit_coordinator": "ஒருங்கிணைப்பாளர் திருத்து",
    "notifications.authorization_code_is_no_longer_valid": "அங்கீகாரம் குறியீடு இனி செல்லுபடியாகாது",
    "button.reject": "திருத்தியமைக்க",
    "label.label.participant_status": "பங்கேற்பாளர் நிலை",
    "award.gold_level": "தங்க நிலை",
    "sidebar.variables": "மாறிகள்",
    "parentalConsent.checkbox_copy": "நான் {firstName} {lastName} இன் பெற்றோர் / காப்பாளர் என்று உறுதிப்படுத்துகிறேன். பயிற்சி பெற்ற விருது பெற்ற தலைவரின் மேற்பார்வையின் கீழ் {organisationName} விருது வழங்குவதற்காக நான் அவருக்கு / அவருக்காக என் அனுமதியை வழங்குகிறேன். விருது பெற்ற, விருந்தினராக பங்கேற்க வேண்டிய தேவைகள் மற்றும் நிலைமைகளை நான் வாசித்து, புரிந்து கொண்டு ஒப்புக்கொள்கிறேன், மேலே குறிப்பிட்டது மற்றும் விருது ஆபரேட்டர் வலைத்தளத்தின் மீது.",
    "button.go_to_dashboard": "டாஷ்போர்டுக்குச் செல்",
    "button.add_option": "விருப்பத்தைச் சேர்",
    "label.is_completed": "நிறைவடைந்துவிட்டது",
    "pageTitle.award_units": "விருது பிரிவுகள்",
    "states.completed": "நிறைவடைந்துவிட்டது",
    "button.adventurous_journey_template_settings": "சாகச பயண டெம்ப்ளேட் அமைப்புகள்",
    "label.system_rights": "கணினி உரிமைகள்",
    "label.assessor_assesstment_award_start_date": "label.assessor_assesstment_award_start_date",
    "label.update_translation_question": "",
    "button.login": "உள் நுழை",
    "label.name_of_the_unit": "அலகு பெயர்",
    "button.send": "அனுப்புக",
    "award.ajs": "சாகச பயணங்கள்",
    "meta.payments_expired": "பண வழங்கீடு - காலாவதியானது",
    "label.age": "வயது",
    "notifications.payment_info_updated": "கட்டண தகவல் மேம்படுத்தப்பட்டது",
    "table.is_completed": "நிறைவடைந்துவிட்டது",
    "table.invited_by": "அழைக்கப்பட்டது",
    "route.files": "கோப்புகள்",
    "route.assessors": "மதிப்பீட்டாளர்கள்",
    "info.aj_supervisor_is_mandatory": "",
    "pageTitle.my_participants": "என் பங்கேற்பாளர்கள்",
    "label.change_leader_status": "தலைவரின் நிலைமையை மாற்றுக",
    "moduleTitle.parent_consent_form": "பெற்றோர் / கார்டியன் ஒப்புதல் படிவம்",
    "notifications.authorization_contact_has_been_set": "அங்கீகார தொடர்பு அமைக்கப்பட்டுள்ளது",
    "button.close": "மூடு",
    "label.independent_country": "சுதந்திர நாடு",
    "notifications.aj_preparation_training_has_been_returned": "சாகச பயணத்தின் தயாரிப்பு & பயிற்சி திருத்தப்பட்டது",
    "route.history_log": "வரலாறு பதிவு",
    "participant.account_settings": "கணக்கு அமைப்புகள்",
    "label.bulk_action_error_item": "",
    "label.orb_account": "",
    "notifications.file_url_is_not_specified_in_configuration": "கோப்பு URL உள்ளமைவில் குறிப்பிடப்படவில்லை",
    "notifications.award_unit_has_been_removed": "விருது பிரிவு / ஐஏசி நீக்கப்பட்டது",
    "table.parent": "பெற்றோர்",
    "label.mode_of_transport": "போக்குவரத்து முறை",
    "label.parental_consent_email_info": "பெற்றோர் மின்னஞ்சல் சரிபார்க்க மறக்க வேண்டாம் மற்றும் விருது விவரம் திரையில் இருந்து கைமுறையாக ஒப்புதல் அனுப்ப.",
    "label.current_award": "தற்போதைய விருது",
    "table.action": "நடவடிக்கை",
    "pageTitle.suboperating_authorities": "துணை இயக்க அதிகாரங்கள்",
    "notifications.award_leader_has_been_assigned": "விருதுத் தலைவர் நியமிக்கப்பட்டுள்ளார்",
    "tabs.sign_offs_locally": "உள்ளூர் அங்கீகாரம்",
    "Activity log has been restored": "notification.log_has_been_restored",
    "sidebar.naos": "NAOs",
    "tabs.aj_templates": "சாகச பயணத்தின் டெம்ப்ளேட்",
    "notifications.logging_out": "வெளியேறுதல் ...",
    "label.update_label": "",
    "button.organisation_settings": "குழு அமைப்புகள்",
    "tabs.independent_award_centers": "சுதந்திர விருது மையங்கள்",
    "label.current": "",
    "table.location": "இட அமைவு",
    "button.search": "தேடல்",
    "notifications.aj_preparation_training_has_been_approved": "சாகச பயணத்தின் தயாரிப்பு & பயிற்சி திருத்தப்பட்டது",
    "route.participants": "பங்கேற்பாளர்கள்",
    "label.other_location_information": "பிற இருப்பிடத் தகவல்",
    "label.number_of_records": "பதிவுகள் எண்ணிக்கை",
    "translationsManagement.infoLabel": "translationsManagement.infoLabel",
    "parentalConsent.i_consent_to_pay_all": "5. அத்தகைய விபத்து, காயம், நோய்வாய்ப்பட்ட அல்லது பங்கேற்பாளரால் பாதிக்கப்பட்ட அல்லது இழக்க நேரிடும் எந்தவொரு நோயாளியின் சார்பாகவும் அத்தகைய மருத்துவர்கள், நர்ஸ்கள் அல்லது மருத்துவமனை விடுதி கட்டணங்கள் மற்றும் செலவினங்களைச் செலுத்த நான் ஒப்புக்கொள்கிறேன்.",
    "label.nationality": "குடியுரிமை",
    "states.approval": "ஒப்புதல்",
    "notifications.something_went_wrong": "ஏதோ தவறு நடந்துவிட்டது",
    "aj.practice": "பயிற்சி",
    "label.addressLine2": "இரண்டாவது வரி முகவரி",
    "label.please_leave_a_note": "தயவுசெய்து ஒரு குறிப்பு விடுங்கள்",
    "placeholder.select": "தேர்ந்தெடு",
    "label.observations": "கவனிப்புகள்",
    "label.aim": "நோக்கம்",
    "label.addressLine1": "முகவரி முதல் வரி",
    "roles.aj_instructor": "AJ பயிற்றுவிப்பாளர்",
    "meta.payments_waiting": "பண வழங்கீடு - காத்திருக்கிறது",
    "label.award_to_delete": "",
    "label.category": "",
    "roles.instructor": "பயிற்றுவிப்பாளர்",
    "moduleTitle.remove_customization_and_reset": "தனிப்பயனாக்கத்தை அகற்றி, கட்டமைப்பு மதிப்பு மீட்டமைக்கவா?",
    "notifications.participant_registration_has_been_restored": "பங்கேற்பாளர் பதிவு மீட்டமைக்கப்பட்டுள்ளது",
    "organisation.change_award_unit_mode": "அமைப்பு முறை மாற்றவும்",
    "table.organization_type": "",
    "notifications.participant_has_been_deleted": "பங்கேற்பாளர் நீக்கப்பட்டது",
    "label.language_settings": "மொழி அமைப்புகள்",
    "notifications.event_has_been_approved": "நிகழ்வு ஏற்றுக்கொள்ளப்பட்டது",
    "label.password": "கடவுச்சொல்",
    "label.text": "உரை",
    "table.observations": "கவனிப்புகள்",
    "notifications.participant_has_been_created": "பங்கேற்பாளர் உருவாக்கப்பட்டது",
    "table.note_for_al": "விருதுத் தலைவருக்கு குறிப்பு",
    "label.payment_confirmed": "கட்டன சேவை உறுபடுத்தப்பட்டது",
    "label.previous_completed_award_level": "முந்தைய நிலை (ORB அல்ல)",
    "pageTitle.new_aj_event": "புதிய சாகச பயண நிகழ்வுகள்",
    "label.backend": "label.backend",
    "label.relationship_to_participant": "பங்குதாரர் உறவு",
    "award.physical_recreation": "உடல் ரீதியிலான பொழுதுபோக்கு",
    "contact.collect_emails": "",
    "moduleTitle.assessor_report_reject": "மதிப்பீட்டாளர் அறிக்கை நிராகரிக்கப்பட்டது",
    "label.supervisor_report": "மேற்பார்வையாளர் அறிக்கை",
    "table.role": "பங்கு",
    "route.user_guide_web_nao": "பயனர் இணையதளம் வழிகாட்டி - NAO",
    "label.page_not_found": "404 - பக்கம் காணப்படவில்லை.",
    "table.labels": "",
    "notifications.file_has_been_uploaded": "கோப்பு பதிவேற்றப்பட்டது",
    "moduleTitle.address": "முகவரி",
    "moduleTitle.lead_coordinator": "ஒருங்கிணைப்பாளர் முன்னணி",
    "pageTitle.login": "உள் நுழை",
    "label.frontoffice": "label.frontoffice",
    "participant.would_you_like_to_remove_registration": "",
    "notifications.rp_has_been_setup": "ரெசிடென்ஷியல் ப்ராஜெக்ட் அமைக்கப்பட்டது",
    "moduleTitle.award_unit": "விருதுப் பிரிவு",
    "button.remove_file": "கோப்பை அகற்று",
    "moduleTitle.billing_address": "பில்லிங் முகவரி",
    "pageTitle.my_aj_events": "என் சாகச பயண நிகழ்வுகள்",
    "route.tasks": "பணிகள்",
    "button.confirm": "உறுதிப்படுத்தவும்",
    "label.national_award_authority": "தேசிய விருது ஆணையம்",
    "label.independent_award_centre": "சுதந்திர விருது மையம்",
    "award.generate_award_report": "புகாரை உருவாக்குக",
    "route.my_region_office_customization": "எனது பிராந்திய அலுவலகம் - தன்விருப்பமாக்குதல்",
    "label.email_help_aj_category": "",
    "label.your_report_has_been_rejected": "",
    "notifications.password_change_request_has_been_sent": "கடவுச்சொல் மாற்ற கோரிக்கை அனுப்பப்பட்டது",
    "tabs.detail": "விவரம்",
    "participant.change_participant_status": "பங்கேற்பாளரின் நிலைமையை மாற்றவும்",
    "table.key": "",
    "label.find_address": "முகவரி கண்டுபிடிக்கவும்",
    "notifications.assessor_has_been_rejected": "மதிப்பீட்டாளர் திருத்தப்பட்டுள்ளார்",
    "label.transfer_participants": "பங்கேற்பாளர்களின் இடமாற்றம்",
    "button.continue_to_payment_gateway": "கட்டணம் நுழைவாயிளுக்கு தொடரவும்",
    "notifications.participant_registration_has_been_removed": "பங்கேற்பாளர் பதிவு நீக்கப்பட்டது",
    "moduleTitle.page_not_found": "404 - பக்கம் காணப்படவில்லை",
    "route.adventurous_journeys": "சாகச பயணங்கள்",
    "states.registration_assessment": "பதிவு மதிப்பீடு",
    "heading.change_award_unit_mode": "விருது யூனிட் முறை மாற்றவும்",
    "label.user_guide_web_nao": "பயனர் இணையதளம் வழிகாட்டி - NAO",
    "tabs.silver_level": "வெள்ளி நிலை",
    "table.paid_by": "பணம் செலுத்தியது",
    "label.your_report_has_been_successfully_sent": "உங்கள் அறிக்கை வெற்றிகரமாக அனுப்பப்பட்டது.",
    "sidebar.my_organization": "என் அமைப்பு",
    "pageTitle.participants": "பங்கேற்பாளர்கள்",
    "notifications.preparation_training_has_been_updated": "தயாரிப்பு மற்றும் பயிற்சி மேம்படுத்தப்பட்டது",
    "moduleTitle.server_is_unreachable": "சேவையகம் கிடைக்கவில்லை",
    "label.last_activity_date": "",
    "award.bronze_level": "வெண்கல நிலை",
    "moduleTitle.award_units": "விருது அலகுகள்",
    "table.completed": "நிறைவடைந்து",
    "moduleTitle.revise_message": "செய்தியைத் திருத்தவும்",
    "table.lastUsed": "",
    "award.bronze_to_gold_level": "வெண்கலத்திலிருந்து தங்க விருது",
    "button.change_password": "கடவுச்சொல்லை மாற்று",
    "label.nao_price": "NAO விலை",
    "label.payment_state": "கட்டண நிலை",
    "label.wwc_expired": "WWC காலாவதியானது",
    "label.award_office_signoff_date": "விருது அலுவலகம் பதிவு தேதி",
    "label.award_unit": "விருதுப் பிரிவு",
    "award.gold_level_short": "தங்கம்",
    "moduleTitle.other_info": "பிற தகவல்",
    "table.note": "குறிப்பு",
    "label.search_by_email_first_or_last": "மின்னஞ்சல், முதல் அல்லது கடைசி பெயர் மூலம் தேடலாம்",
    "tabs.history": "வரலாறு",
    "notifications.label_has_been_created": "",
    "tabs.unassigned_participants": "ஒதுக்கப்படாத பங்கேற்பாளர்கள்",
    "table.main_award_leader": "ஒருங்கிணைப்பாளர்",
    "parentalConsent.i_as_the_parent": "3. சில நடவடிக்கைகள் அதிக அபாயகரமானவை எனக் கருதுகின்றேன் மற்றும் அபாயகரமான செயற்பாடுகள் விருது ஆபரேட்டரின் காப்பீட்டு ஏற்பாடுகளால் மூடப்படாது என்பதை நான் புரிந்து கொள்கிறேன். பங்கேற்பாளர் பங்கேற்பாளரின் பங்களிப்பிலிருந்து எழும் எல்லா ஆபத்துக்களுக்கும் பொறுப்பானவர் பங்காளியின் மீது மட்டுமே வைக்கிறார் என்பதை நான் புரிந்து கொள்கிறேன்.",
    "label.state": "நிலை",
    "notifications.award_leader_has_been_removed": "விருதுத் தலைவர் நீக்கப்பட்டுள்ளார்",
    "tabs.organization_detail": "Organisation Details\n",
    "table.operating_authorities": "இயக்க அதிகாரங்கள்",
    "label.available_labels": "",
    "modal.select": "தேர்ந்தெடு",
    "tabs.expired_payments": "காலாவதியான கட்டணம்",
    "moduleTitle.note_for_al": "விருதுத் தலைவருக்கு குறிப்பு",
    "moduleTitle.confirm": "உறுதிப்படுத்து",
    "notification.new_activity_added": "புதிய செயல்பாடு சேர்க்கப்பட்டுள்ளது",
    "notifications.award_leader_has_been_moved": "விருதுத் தலைவர் நகர்த்தப்பட்டுள்ளார்",
    "label.award_mode": "விருது முறை",
    "label.phone": "தொலைபேசி",
    "notifications.organization_has_been_updated": "அமைப்பு புதுப்பிக்கப்பட்டது",
    "moduleTitle.assessor": "மதிப்பீட்டாளர்",
    "label.bulk_action_confirmation": "",
    "table.parent_approval": "பெற்றோர் ஒப்புதல்",
    "label.date_of_delivery": "பெறப்பட்ட தேதி",
    "sidebar.assessors": "மதிப்பீட்டாளர்கள்",
    "label.journey_activity": "பயணத்தின் செயல்பாடு",
    "award.inactive_award": "செயலிழந்த விருது",
    "label.end_date": "கடைசி தேதி",
    "label.orb_testing": "",
    "label.no_activities": "செயல்பாடுகள் இல்லை",
    "moduleTitle.please_confirm": "தயவுசெய்து உறுதிப்படுத்துங்கள்",
    "button.login_with_another_account": "வேறு அக்கௌன்ட் உடன் உள்நுழையவும்",
    "tasks.reject_registration": "பதிவுசெய்தல் மறுபரிசீலனை",
    "label.submitted_after_date": "பிறகு சமர்ப்பிக்கப்பட்டது",
    "label.update_translations_successful": "",
    "button.assign_leader": "தலைவர் நியமனம்",
    "table.already_running": "ஏற்கனவே இயங்குகிறது",
    "label.no": "No",
    "label.count_items_selected": "",
    "label.secondary_phone_number": "இரண்டாம் நிலை தொலைபேசி எண்",
    "label.my_experience": "என்னுடைய அனுபவம்",
    "notifications.adventurous_journey_has_been_approved": "சாகச பயணம் அங்கீகரிக்கப்பட்டுள்ளது",
    "pageTitle.mro_detail": "எனது பிராந்திய அலுவலகம் - விவரம்",
    "moduleTitle.nao_specific_info": "NAO குறிப்பிட்ட தகவல்",
    "label.preparing_document_for_import": "இறக்குமதி செய்ய ஆவணம் தயாராகிறது",
    "tasks.observations": "கவனிப்புகள்",
    "notifications.confirmation_email_has_been_sent": "உறுதிப்படுத்தல் மின்னஞ்சல் அனுப்பப்பட்டது",
    "button.restore": "மீட்டமை",
    "label.importing_file": "கோப்பை இறக்குமதி செய்கிறது",
    "label.or_dont_agree": "இல்லையா? உன்னால் முடியும்",
    "moduleTitle.award_leader": "விருதுத் தலைவர்",
    "label.me": "எனக்கு",
    "tabs.sub_global_operating_partners": "",
    "button.export_table": "ஏற்றுமதி அட்டவணை",
    "organisation.move_award_unit": "விருதுப் பிரிவை நகர்த்து",
    "label.file_category": "",
    "notifications.connecting_to_server": "சேவையகத்துடன் இணைக்கப்படுகிறது...",
    "parentalConsent.i_understand_that_a_and_b": "<br /> <br /> <br /> \" பங்கேற்பாளர் ஒரு பொருத்தமான வாகன உரிமையாளர் வைத்திருக்கும் வரை பங்குதாரர் பங்கேற்பாளரின் வாகனம் ஓட்டுவதற்கு அல்லது மோட்டார் வாகனத்தை ஓட்டக்கூடாது அல்லது பங்கேற்பாளருக்கு ஓட்டுநர் உரிமத்தை வழங்குவதில்லை. ; <br /> ப. ஒரு பங்கேற்பாளர் எந்தவொரு தனிநபரும் பொருத்தமான அல்லது செல்லுபடியாகும் ஓட்டுநர் உரிமம் வைத்திருக்கும்பட்சத்தில், அதில் பங்கு பெறும் நோக்கத்திற்காக விருது வழங்குவதில் பங்கேற்கவோ அல்லது உதவி செய்யவோ எந்தவொரு நபரும் இயக்கப்படக்கூடாது. நபரின் வாகனம் ஓட்டியதன் விளைவாக காயம் ஏற்பட்டது.",
    "table.reason": "",
    "pageTitle.contacts": "தொடர்புகள்",
    "states.award_leader_approval": "விருதுகள் தலைவர் கையெழுத்திடு",
    "meta.payments": "பண வழங்கீடு",
    "label.suboperating_authority": "துணை இயக்க ஆணையம்",
    "route.my_region_office": "எனது பிராந்திய அலுவலகம்",
    "states.registration_not_approved": "பதிவு அங்கீகரிக்கப்படவில்லை",
    "label.direct_entrant": "நேரடி வாரிசு",
    "tabs.all_participants": "அனைத்து பங்கேற்பாளர்கள்",
    "tabs.payment": "பண வழங்கீடு",
    "label.email_help_activity_name": "",
    "title.update_report": "",
    "label.repeat_new_password": "புதிய கடவுச்சொல்லை மீண்டும் செய்யவும்",
    "label.other_roles": "",
    "logs.hours": "மணிகள்",
    "notifications.spreadsheet_has_been_imported_successfully": "விரிதாள் வெற்றிகரமாக இறக்குமதி செய்யப்பட்டது",
    "label.bulk_action_question": "",
    "moduleTitle.personal_details": "சொந்த விவரங்கள்",
    "label.bulk_action_emailing": "",
    "route.my_events": "என் நிகழ்வுகள்",
    "button.delete_award": "",
    "errors.include_both_lower_and_upper_case": "குறைந்த மற்றும் மேல் வழக்கு எழுத்துக்கள் சேர்த்தவும்",
    "tabs.removed_participant_registrations": "பங்கேற்பாளர் பதிவு நீக்கப்பட்டது",
    "sidebar.mynao": "என் NAO",
    "tabs.office_details": "அலுவலக விவரங்கள்",
    "label.major": "பெரும்பான்மை",
    "tabs.documents": "ஆவணங்கள்",
    "label.new_password": "புதிய கடவுச்சொல்",
    "sidebar.adventure_journey": "சாகச பயணம்",
    "pageTitle.customizations": "தன்விருப்பமாக்குதல்",
    "moduleTitle.assessor_report": "{role} அறிக்கை",
    "label.registration_date": "பதிவு தேதி",
    "notifications.training_has_been_added": "பயிற்சி சேர்க்கப்பட்டுள்ளது",
    "aj.qualifying": "தகுதி பெறு",
    "moduleTitle.you_have_been_logged_out_session_terminated": "அமர்வு ஏற்கனவே நிறுத்தப்பட்டதால் நீங்கள் வெளியேற்றப்பட்டுள்ளீர்கள்",
    "award.service": "சேவை",
    "notifications.rp_state_has_been_changed": "ரெசிடென்ஷியல் ப்ராஜெக்ட் நிலை மாற்றப்பட்டுள்ளது",
    "label.ctest_access": "",
    "table.created": "உருவாக்கப்பட்டது",
    "tasks.revise_task": "பணி மறுபரிசீலனை",
    "button.assign": "நியமி",
    "button.return": "திருத்தியமைக்க",
    "table.status": "நிலைமை",
    "button.restore_activity": "செயல்பாட்டை மீட்டெடுக்கவும்",
    "tabs.new_aj_event": "புதிய சாகச பயண நிகழ்வு",
    "roles.if_staff_viewer": "IF பணியாளர் பார்வையாளர்",
    "notifications.new_template_has_been_created": "புதிய டெம்ப்ளேட் உருவாக்கப்பட்டது",
    "global.something_went_wrong": "ஏதோ தவறு நடந்துவிட்டது",
    "table.expire_day": "காலாவதியாகும் தேதி",
    "tabs.history_log": "வரலாறு பதிவு",
    "label.form_of_payment": "கட்டணத்தை படிவம்",
    "button.add_training": "பயிற்சி சேர்க்க",
    "label.par_reg_cust_note": "பங்கேற்பாளர் பதிவுகளில் காண்பிக்கப்படும் புலங்களை தனிப்பயனாக்க மற்றும் நீங்கள் சேகரிக்கும் தரவின் அளவை பாதிக்க அனுமதிக்க இந்த தாவல் அனுமதிக்கிறது. மாற்றங்கள் செய்யப்பட வேண்டுமெனில் உங்கள் பிராந்திய அலுவலகத்தைத் தொடர்பு கொள்ளவும் - IAF System Admin க்கு இந்த மாற்றங்களைச் செய்ய அணுக முடியும்.",
    "label.my_qualification": "என் தகுதி",
    "button.add_new_profile_question": "புதிய சுயவிவரக் கேள்வியைச் சேர்க்கவும்",
    "table.operating_authority": "இயக்க ஆணையம்",
    "table.aim": "இலக்கு",
    "table.awards": "விருதுகள்",
    "participant.deactivate_account": "அக்கௌன்ட் ஐ செயலிழக்க",
    "table.organization_name": "",
    "label.email_help_award_leader_first_name": "",
    "table.date": "தேதி",
    "tasks.would_you_like_to_delete": "இந்த பங்கேற்பாளரை நீக்க விரும்புகிறீர்களா?",
    "notifications.configuration_value_has_been_updated": "கட்டமைப்பு மதிப்பு புதுப்பிக்கப்பட்டது",
    "ajTemplates.fill_from_template": "டெம்ப்ளேடில் இருந்து நிரப்பவும்",
    "contact.send_test_email": "டெஸ்ட் மின்னஞ்சல் அனுப்பு",
    "moduleTitle.aj_preparation_and_training": "சாகச பயணத்தின் தயாரிப்பு & பயிற்சி",
    "label.ce_be": "",
    "button.notify_participant": "",
    "label.parent_phone": "பெற்றோர் / கார்டியன் தொலைபேசி எண்",
    "label.nao_regulations": "",
    "award.skills": "திறன்கள்",
    "label.reject_application": "இந்த பயன்பாட்டை நிராகரிக்கவும்.",
    "leader.delete_account": "தொடர்பு நீக்கு",
    "table.assign": "ஒதுக்க",
    "roles.aj_supervisor": "சாகச பயணத்தின் மேற்பார்வையாளர்",
    "label.logout": "வெளியேறு",
    "moduleTitle.award_leader_edit": "விருதுத் தலைவரை தொகுத்தமை",
    "moduleTitle.training": "பயிற்சி",
    "notifications.coordinator_has_been_removed": "ஒருங்கிணைப்பாளர் நீக்கப்பட்டுள்ளார்",
    "tabs.operating_partners": "",
    "moduleTitle.main_award_leader": "ஒருங்கிணைப்பாளர்",
    "label.bulk_action_successful": "",
    "tasks.clear_email_revision": "",
    "table.preparation": "தயாரிப்பு",
    "table.delete": "நீக்கு",
    "label.safeguarding_policy": "",
    "sidebar.reports": "அறிக்கைகள்",
    "pageTitle.sub_global_operating_partners": "",
    "label.is_major_activity_confirmation": "",
    "pageTitle.operating_authorities": "இயக்க அதிகாரங்கள்",
    "label.delete_participant_award_modal_question_detail": "",
    "label.confirmed": "உறுதிப்படுத்தப்பட்டது",
    "notifications.invitation_has_been_sent": "அழைப்பிதழ் அனுப்பப்பட்டுள்ளது",
    "pageTitle.independent_countries": "சுதந்திர நாடுகள்",
    "label.assessors_email": "மதிப்பீட்டாளரின் மின்னஞ்சல்",
    "tasks.approve_assessor_registration": "மதிப்பீட்டாளர் பதிவு அங்கீகரிக்க",
    "table.award_duration": "விருது காலம்",
    "notifications.organization_has_been_moved": "அமைப்பு நகர்த்தப்பட்டது",
    "pageTitle.nao_payment": "தேசிய அலுவலகம் - கொடுப்பனவு",
    "participant.history_log": "வரலாறு பதிவு",
    "label.rejected_with_note": "",
    "label.already_running": "ஏற்கனவே இயங்குகிறது",
    "button.continue": "button.continue",
    "award.no_data_to_show": "காட்ட எந்த தகவலும் இல்லை",
    "participant.send_email_invitation_again_question": "மின்னஞ்சல் அழைப்பை மீண்டும் அனுப்பவா?",
    "label.reason_for_changing_assessor": "மதிப்பீட்டாளரை மாற்றுவதற்கான காரணம்",
    "button.delete": "நீக்கு",
    "moduleTitle.requirements_and_conditions": "தேவைகள் மற்றும் நிபந்தனைகள்",
    "roles.leader": "தலைவர்",
    "label.if_download_doesnt": "பதிவிறக்க தானாக இயங்கவில்லையெனில், உங்கள் உலாவியில் பாப் அமைப்புகளை சரிபார்க்கவும்",
    "dashboard.your_todo_list": "உன் செய்யவேண்டிய பட்டியல்",
    "notifications.award_unit_has_been_returned": "விருது பிரிவு திருத்தப்பட்டது",
    "moduleTitle.participant_activities": "பங்கேற்பாளரின் நடவடிக்கைகள்",
    "errors.qualification_or_experience_required": "",
    "label.active_leaders": "விருது தலைவர்கள்",
    "aj.preparation": "தயாரிப்பு",
    "button.change_state": "நிலையை மாற்றவும்",
    "label.current_password": "தற்போதைய கடவுச்சொல்",
    "pageTitle.global_operating_partners": "",
    "moduleTitle.contact_settings": "தொடர்பு அமைப்புகள்",
    "button.remove_photo": "புகைப்படத்தை அகற்று",
    "notifications.activity_has_been_setup": "செயல்பாடு அமைக்கப்பட்டது",
    "errors.must_be_more_than": "{limit} ஐ விட அதிகமாக இருக்க வேண்டும்",
    "table.goal": "நோக்கம்",
    "notifications.coordinator_has_been_set": "ஒருங்கிணைப்பாளர் அமைத்துள்ளார்",
    "label.cc": "Cc",
    "label.duration": "கால வரையறை",
    "table.actions": "செயல்கள்",
    "participant.send_email_invitation_again": "மின்னஞ்சல் அழைப்பை மீண்டும் அனுப்பவா?",
    "moduleTitle.would_you_like_to_remove_participant": "இந்த பங்கேற்பாளர் பதிவை நீக்க விரும்புகிறீர்களா?",
    "parentalConsent.i_authorise_employees": "4. விருது வழங்கும் பிரிவின் ஊழியர்கள், அலுவலர்கள் அல்லது முகவர்கள் மற்றும் பங்கேற்பாளர்களால் பாதிக்கப்பட்ட ஏதேனும் விபத்து, காயம், நோய் அல்லது இழப்பு ஏற்பட்டால், பங்கேற்கிற மற்ற நபர்கள், பங்கேற்பாளர்களுக்கு ஏற்பாடு செய்வதில் அல்லது உதவுவதில் நான் ஈடுபடுகிறேன். , அல்லது எந்தவொரு மருத்துவ வசதி அல்லது மருத்துவ சிகிச்சை அல்லது மருத்துவ சிகிச்சையைப் பெறுதல், எந்த மருத்துவர்கள், நர்ஸ்கள் அல்லது மருத்துவமனையிலிருந்தும் ஈடுபடுத்துதல் போன்றவை உட்பட, எந்தவொரு நடவடிக்கைகளோ அல்லது செயல்பாடுகளோ, அல்லது பயணம் செய்யவோ அல்லது பயணம் செய்யவோ ஆகியவற்றில் ஈடுபடுவதோடு மட்டுமல்லாமல் மட்டுமின்றி",
    "button.reload_page": "பக்கத்தை மீண்டும் ஏற்றவும்",
    "moduleTitle.update_translations": "",
    "label.report_description": "",
    "table.email": "மின்னஞ்சல்",
    "label.new_goal": "புதிய நோக்கம்",
    "label.participant_survey_parent": "",
    "errors.invalid_email_address": "தவறான மின்னஞ்சல் முகவரி",
    "pageTitle.new_contact": "புதிய தொடர்புகள்",
    "sidebar.gops": "",
    "button.manage_participants": "பங்குதாரர்களை நிர்வகிக்கவும்",
    "errors.invalid_phone_format": "தவறான தொலைபேசி எண்",
    "notifications.login_details_have_been_changed": "உள்நுழைவு விவரங்கள் மாற்றப்பட்டுள்ளன",
    "moduleTitle.participant_logs": "பங்கேற்பாளரின் பதிவுகள்",
    "label.save": "சேமி",
    "label.frequently_asked_questions": "அடிக்கடி கேட்கப்படும் கேள்விகள் (FAQs)",
    "label.city": "பெருநகரம்",
    "notifications.configuration_value_has_been_reset": "கட்டமைப்பு மதிப்பு மீட்டமைக்கப்பட்டுள்ளது",
    "states.office_sign_off": "விருது அலுவலகம் கையெழுத்து",
    "button.save": "சேமி",
    "button.import_data_from_selected_file": "தேர்ந்தெடுத்த கோப்பில் இருந்து தரவை இறக்குமதி செய்யவும்",
    "parentalConsent.i_understand_that_the_participant_cannot": "9. விருது பெற்ற பிரிவில் பணியாற்றிய எந்தவொரு வாலண்டியரும், தகுதியற்ற அனுபவம் மற்றும் / அல்லது மேற்பார்வையிட / மேற்பார்வை / மேற்பார்வை செய்ய தகுதியுடையவர் / விருது அந்த பகுதியை மதிப்பீடு; எந்தவொரு பொருத்தமான தொண்டர்களும் பூர்த்தி செய்து, விருதுப் பிரிவுக்கு தேவையான ஆவணங்களைத் திருப்பித் தரும் வரை.",
    "pageTitle.apiKeys": "",
    "label.international_region": "சர்வதேச பகுதி",
    "tabs.levels": "நிலைகள்",
    "tabs.additional_files": "கூடுதல் கோப்புகள்",
    "label.continuation_level": "தொடர் நிலை",
    "table.adventurous_journey_detail": "சாகச பயணம் விவரங்கள்",
    "button.set": "அமை",
    "label.i_certify_that_as_the_assessor": "பங்குதாரர் தேவைகளை பூர்த்தி செய்து கொண்டிருக்கும் இந்த செயல்பாட்டின் {role} என நான் சான்றளிக்கிறேன்.",
    "table.coordinator": "ஒருங்கிணைப்பாளர்",
    "participant.send_confirmation_email_again": "உறுதிப்படுத்தல் மின்னஞ்சலை மீண்டும் அனுப்பவா?",
    "table.report": "அறிக்கை",
    "label.update_translations_results": "",
    "table.observation_note": "கவனிப்பு குறிப்பு",
    "label.view_more": "மேலும் பார்க்க",
    "notifications.payment_link_has_been_reset": "கட்டண இணைப்பு மீட்டமைக்கப்பட்டது",
    "table.type": "Type",
    "moduleTitle.updateConfigurationKey": "கட்டமைப்பு விசை புதுப்பிக்கவும்",
    "sidebar.independent_award_centers": "சுதந்திர விருது மையங்கள்",
    "table.activity_type": "செயல்பாட்டு வகை",
    "label.awardMode.online": "ஆன்லைன்",
    "table.data_state": "",
    "button.generate_report": "புகாரை உருவாக்குக",
    "moduleTitle.assessed_by_award_leader": "விருதுத் தலைவரால் மதிப்பீடு செய்யப்பட்டது",
    "table.child_protection_number": "குழந்தை பாதுகாப்பு எண்",
    "button.bulk_change": "",
    "label.send_welcome_email": "",
    "label.award_state": "விருது நிலை",
    "moduleTitle.overview": "கண்ணோட்டம்",
    "table.aj_detail": "சாகச பயண விபரம்",
    "pageTitle.tasks_activity_approvals": "செயட்பாட்டு அனுமதி",
    "label.section": "பிரிவு",
    "route.history": "வரலாறு",
    "route.event_participants": "நிகழ்வு பங்கேற்பாளர்கள்",
    "participant.account_detail": "கணக்கு அமைப்புகள்",
    "route.dashboard": "டாஷ்போர்டு",
    "table.payments": "பண வழங்கீடு",
    "pageTitle.profile": "தோற்ற வடிவம்",
    "organisation.remove_organisation": "அமைப்பு அகற்று",
    "pageTitle.my_organization": "எனது அமைப்பு",
    "label.award_leader": "",
    "notifications.assessor_has_been_updated": "மதிப்பீட்டாளர் புதுப்பிக்கப்பட்டுள்ளார்",
    "label.participant_personal_reflection": "",
    "button.add_key": "",
    "header.appMotto": "டியூக்",
    "table.qualifying": "தகுதி பெறு",
    "button.upload": "பதிவேற்றம்",
    "button.resend": "மீண்டும் அனுப்பு",
    "label.filename": "கோப்புபெயர்",
    "label.change_parental_consent": "",
    "button.cancel": "ரத்து",
    "label.aply_to_all_langs": "",
    "route.customization": "தன்விருப்ப",
    "errors.minimal_duration_is": "குறைந்தபட்சம் 30 நிமிடம் ஆகும்",
    "label.email_help_participant_first_name": "",
    "label.participant_status": "பங்கேற்பாளர் நிலை",
    "award.bronze_level_short": "வெண்கலம்",
    "label.phone_type": "தொலைபேசி வகை",
    "global.night": "இரவு",
    "button.adventurous_journey_settings": "சாகச பயண அமைப்புகள்",
    "participant.leader_must_be_selected": "தலைவர் தேர்ந்தெடுக்கப்பட வேண்டும்",
    "pageTitle.translationsManagement": "",
    "moduleTitle.user_added_preparation_and_training": "தயாரிப்பு மற்றும் பயிற்சி பயனர் சேர்த்தார்",
    "table.approve": "ஒப்புதல்",
    "label.role_in_organisation": "நிறுவனத்தில் பங்கு",
    "states.finished": "முடிந்தது",
    "label.created": "உருவாக்கப்பட்டது",
    "button.back_to_home": "முகப்புக்குச் செல்",
    "label.options": "விருப்பங்கள்",
    "contact.next_level_invitation": "அடுத்த நிலை அழைப்பு",
    "moduleTitle.activity_detail": "Activity Detail\n",
    "route.section_signoff": "பிரிவு உள்நுழைவு",
    "moduleTitle.assign_labels_bulk": "",
    "button.contact_settings": "தொடர்பு அமைப்புகள்",
    "label.transation_id": "பரிவர்த்தனை ஐடி",
    "notifications.activity_has_been_updated": "செயல்பாடு மேம்படுத்தப்பட்டது",
    "sidebar.awards": "விருதுகள்",
    "parentalConsent.images_consent": "பெற்றோர் / காப்பாளர், விளம்பர நோக்கங்களுக்காக அறக்கட்டளை பயன்படுத்த எந்த படங்களையும் நான் ஒப்புக்கொள்கிறேன்.",
    "participant.would_you_like_to_delete": "இந்த கணக்கை நீக்க விரும்புகிறீர்களா?",
    "roles.user": "புள்ளியியல்",
    "label.label": "",
    "label.select_sheet": "",
    "global.no_results": "முடிவுகள் இல்லை",
    "moduleTitle.address_line_2": "இரண்டாவது வரி முகவரி",
    "states.awaiting_office_sign_off": "விருது அலுவலகம் கையெழுத்து",
    "moduleTitle.export": "ஏற்றுமதி",
    "moduleTitle.address_line_1": "முகவரி முதல் வரி",
    "notifications.participant_has_been_assigned": "பங்கேற்பாளர் நியமிக்கப்பட்டுள்ளார்",
    "roles.viewer": "பார்வையாளர்",
    "label.participants_total": "பங்கேற்பாளர்கள் மொத்தம்",
    "errors.auth_code_is_no_longer_valid": "அங்கீகரிப்புக் குறியீடு இனி செல்லுபடியாகாது - இது பயன்படுத்தப்பட்டு இருக்கலாம் அல்லது காலாவதியாகிவிட்டது",
    "label.file_is_not_available": "கோப்பு கிடைக்கவில்லை",
    "button.select_template": "டெம்ப்ளட் தேர்தெடு",
    "label.payment": "பண வழங்கீடு",
    "award.silver_level_short": "வெள்ளி",
    "table.participant_id": "",
    "text.hours_old": "",
    "moduleTitle.your_personal_information": "உங்கள் தனிப்பட்ட தகவல்",
    "aj.minimum_date_recommendation": "பயிற்சி AJ மற்றும் {name} க்கான குறைந்தபட்ச தேதி பரிந்துரை",
    "label.date_of_payment": "கட்டணம் செலுத்தும் தேதி",
    "button.view": "நோக்கு",
    "label.create_new_label": "",
    "title.confirmation": "",
    "button.set_participants": "பங்கேற்பாளர்களை அமைக்கவும்",
    "roles.assessor": "மதிப்பீட்டாளர்",
    "moduleTitle.coordinator_settings": "ஒருங்கிணைப்பாளர் அமைப்புகள்",
    "label.parent_relationship": "பெற்றோரின் உறவு",
    "table.nao": "NAO",
    "notifications.email_has_been_sent": "மின்னஞ்சல் அனுப்பப்பட்டது",
    "label.email_help_participant_full_name": "",
    "sidebar.suboperating_authorities": "துணை இயக்க அதிகாரங்கள்",
    "route.award": "விருது",
    "label.no_roles": "எந்த வேடமும் இல்லை",
    "table.files": "கோப்புகள்",
    "aj.minimum_date_requirements": "AJ மற்றும் {name} தகுதிக்கான குறைந்தபட்ச தேதி தேவை",
    "pageTitle.labels": "",
    "label.participant_is_semi_offline": "பங்கேற்பாளர் ஆஃப்லைன் இல் உள்ளார்",
    "moduleTitle.other_coordinators": "மற்ற ஒருங்கிணைப்பாளர்கள்",
    "button.updateSelectedLanguage": "button.updateSelectedLanguage",
    "tasks.approve_award_registration": "விருது பதிவு ஒப்புதல்",
    "participant.invite_participant_to_next_level": "பங்கேற்பாளரை அடுத்த நிலைக்கு அழைக்கவா?",
    "label.twitter": "ட்விட்டர்",
    "pageTitle.awards": "விருதுகள்",
    "warning.award_marked_as_paid": "",
    "table.edit": "விமர்சனம்",
    "states.change_to_state_warning_missing_hours_to_complete": "",
    "label.dofe": "சர்வதேச விருது",
    "moduleTitle.after_assigning_a_role_to_yourself": "நீங்கள் ஒரு பங்கை ஒதுக்க அல்லது மாற்றுவதற்கு பிறகு நீங்கள் மீண்டும் உள்நுழைய வேண்டும்.",
    "label.transaction_id": "பரிவர்த்தனை ஐடி",
    "table.suboperating_authority": "துணை இயக்க ஆணையம்",
    "label.participant_survey": "ஒரு விருது பங்காளியாக நான் அறக்கட்டளை ஆய்வுகளில் பங்கேற்க சந்தோஷமாக இருக்கிறேன்",
    "label.created_by": "உருவாக்கப்பட்டது",
    "button.send_confirmation_email_again_question": "உறுதிப்படுத்தல் மின்னஞ்சலை மீண்டும் அனுப்பவும்",
    "label.email_help_award_leader_email": "",
    "label.name": "பெயர்",
    "tabs.gold_level": "தங்க நிலை",
    "pageTitle.award_documents": "விருது ஆவணங்கள்",
    "label.online_payments": "ஆன்லைன் பண வழங்கீடு",
    "label.child_protection_number": "குழந்தை பாதுகாப்பு எண்",
    "participant.send_password_recovery_email": "கடவுச்சொல் மீட்பு மின்னஞ்சல் அனுப்ப வேண்டுமா?",
    "notifications.new_log_has_been_added": "புதிய பதிவு சேர்க்கப்பட்டது",
    "moduleTitle.add_gop_role": "",
    "label.organization_name": "குழு பெயர்",
    "pageTitle.my_organization_templates": "எனது அமைப்பு-வார்ப்புருக்கள்",
    "pageTitle.award_leaders": "விருது தலைவர்கள்",
    "label.status": "நிலைமை",
    "label.street": "தெரு",
    "roles.if_staff_superuser": "IF ஊழியர்கள் சூப்பர் பயனர்",
    "table.licence_holder": "உரிமம் உடைமையாளர்",
    "label.created_at": "இல் உருவாக்கப்பட்டது",
    "table.section": "பிரிவு",
    "table.system_rights": "கணினி உரிமைகள்",
    "label.iac_type": "IAC வகை",
    "label.other": "மற்ற",
    "moduleTitle.login": "உள் நுழை",
    "label.no_data_to_show": "காட்டுவதற்கு தகவல் இல்லை",
    "aj.cannot_modify_award_level_if_participants_are_assigned": "பங்கேற்பாளர்கள் சாகச பயணத்திற்கு ஒதுக்கப்பட்டிருந்தால், விருது நிலை திருத்த முடியாது",
    "tabs.waiting_payments": "பண வழங்கீடு காத்திருப்பு",
    "global.supervisor": "மேற்ப்பார்வையாளர்",
    "notifications.new_role_has_been_added": "புதிய பாத்திரம் சேர்க்கப்பட்டது",
    "award.silver_level": "வெள்ளி நிலை",
    "heading.change_awards_mode": "விருது வழங்கும் முறை மாற்றவும்",
    "button.save_changes": "மாற்றங்களை சேமியுங்கள்",
    "organisation.would_you_like_to_move_award_unit": "இந்த அமைப்பை அகற்ற விரும்புகிறீர்களா?",
    "label.fields": "",
    "label.email_help_organization_name": "",
    "pageTitle.mro_related_detail": "எனது பிராந்திய அலுவலகம் - விவரம்",
    "table.started_at": "தொடங்குகிறது",
    "parentalConsent.i_consent_to_the_award_unit": "2. விருதினை ஏற்பாடு செய்வதில் அல்லது உதவுவதில் ஈடுபட்டுள்ள அல்லது தன்னார்வலர்கள் உட்பட, எந்தவொரு தனிநபரும், போக்குவரத்து இயக்குநர்களை வாடகைக்கு எடுத்து, விருதுக்குத் தொடர்புடைய நடவடிக்கைகள் அல்லது செயல்பாடுகளில் பங்கு பெறுவதிலிருந்து பங்குபற்றுபவர், தேவைக்கேற்ப. அத்தகைய பயணத்தை எங்கு எப்போது நடக்கும் என்பதற்கான முன்னுரிமையை விருது வழங்கும் நிறுவனம் அறிவிக்கும் என்பதை நான் புரிந்து கொள்கிறேன்.",
    "logs.minutes": "நிமிடங்கள்",
    "label.total_participants": "மொத்த பங்கேற்பாளர்கள்",
    "moduleTitle.contact_info": "தொடர்பு தகவல்",
    "table.payment_link": "கொடுப்பனவு இணைப்பு",
    "errors.please_contact_your_local_award_staff": "உங்கள் உள்ளூர் விருது ஊழியர்களை தொடர்பு கொள்ளவும்."
}